/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.

    export interface CoreAdminListCompaniesParams {
        companyTypeId: number | null | undefined;
        q: string | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        includeInactive: boolean | null | undefined;
    }
    //
    export interface CoreLoginOktaLoginTypeParams {
        email: string | undefined;
        isMobile: boolean | null | undefined;
        mobileAppVersion: string | null | undefined;
    }
    //
    export interface CoreLoginCaptchaLoginTypeParams {
        email: string | undefined;
    }
    //
    export interface CoreOAuthGetInfoParams {
        access_type: string | null | undefined;
        client_id: string | undefined;
        redirect_uri: string | undefined;
        response_type: string | undefined;
        scope: string | undefined;
        state: string | null | undefined;
        triumphCompanyId: string | null | undefined;
    }
    //
    export interface CoreSelectCarrierGetSelectCarrierDefaultRateParams {
        minutesInPast: number | null | undefined;
    }
    //
    export interface CoreUsersListUsersParams {
        exportReport: boolean | undefined;
    }
    //
    export interface CoreFactorInvoicesSearchInvoicesParams {
        dateTypeId: SearchDateTypeId | null | undefined;
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payeeRelationshipId: string | null | undefined;
        payorId: string | null | undefined;
        q: string | null | undefined;
        isQuickpay: boolean | null | undefined;
        sessionCurrencyId: number | null | undefined;
        startDate: string | null | undefined;
        statusId: number | null | undefined;
        additionalDataItemField: string | null | undefined;
        payeeName: string | null | undefined;
        payorName: string | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
    }
    //
    export interface CoreFactorInvoicesGetInvoiceParams {
        payorId: string | null | undefined;
    }
    //
    export interface CoreFactorInvoicesSearchAllInvoicesParams {
        referenceNumber: string | null | undefined;
        carrierSearch: string | null | undefined;
        payorGuid: string | null | undefined;
    }
    //
    export interface CoreFactorLoadsSearchParams {
        dateTypeId: SearchDateTypeId | null | undefined;
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payorId: string | null | undefined;
        payeeRelationshipId: string | null | undefined;
        q: string | null | undefined;
        sessionCurrencyId: number | null | undefined;
        startDate: string | null | undefined;
        statusId: number | null | undefined;
        additionalDataItemField: string | null | undefined;
        payeeName: string | null | undefined;
        payorName: string | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
    }
    //
    export interface CoreFactorLoadsGetParams {
        payorId: string | null | undefined;
        payeeRelationshipId: string | null | undefined;
    }
    //
    export interface CoreFactorLoadsSearchAllParams {
        referenceNumber: string | null | undefined;
        carrierSearch: string | null | undefined;
        payorGuid: string | null | undefined;
    }
    //
    export interface CoreFactorRelationshipCurrentRelationshipsParams {
        exportReport: boolean | undefined;
        q: string | null | undefined;
        externalPayeeKey: string | null | undefined;
        payorId: string | null | undefined;
        isQP: boolean | null | undefined;
        isPayeeSelectCarrier: boolean | null | undefined;
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        statusId: number[] | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        additionalDataItemField: string | null | undefined;
        factorCompanyId: string | null | undefined;
    }
    //
    export interface CoreFactorRelationshipRelationshipParams {
        payorId: string | null | undefined;
    }
    //
    export interface CoreFactorRelationshipRelationshipNamesParams {
        payorId: string | null | undefined;
        q: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface CoreFactorRelationshipSearchRelationshipsParams {
        payorId: string | undefined;
        q: string | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
    }
    //
    export interface CorePayorCreditNotesSearchParams {
        dateTypeId: SearchDateTypeId | null | undefined;
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payorId: string | null | undefined;
        payeeRelationshipId: string | null | undefined;
        sessionCurrencyId: number | null | undefined;
        q: string | null | undefined;
        startDate: string | null | undefined;
        statusId: number[] | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        additionalDataItemField: string | null | undefined;
    }
    //
    export interface CorePayorFactorsSearchFactorNamesParams {
        companyName: string | null | undefined;
    }
    //
    export interface CorePayorHighwaySearchWatchListParams {
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortAsc: boolean | null | undefined;
        sortField: string | null | undefined;
        statusId: number | undefined;
    }
    //
    export interface CorePayorInsightsGetDashboardInsightsParams {
        startDate: string | null | undefined;
        endDate: string | null | undefined;
    }
    //
    export interface CorePayorInvoicesSearchInvoicesParams {
        dateTypeId: SearchDateTypeId | null | undefined;
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payeeRelationshipId: string | null | undefined;
        payorId: string | null | undefined;
        q: string | null | undefined;
        isQuickpay: boolean | null | undefined;
        sessionCurrencyId: number | null | undefined;
        startDate: string | null | undefined;
        statusId: number[] | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        additionalDataItemField: string | null | undefined;
        factorCompanyId: string | null | undefined;
        isFactored: boolean | null | undefined;
        isDuplicate: boolean | null | undefined;
        excludeRemoved: boolean | null | undefined;
    }
    //
    export interface CorePayorInvoicesGetBulkInvoiceTermsParams {
        dateTypeId: SearchDateTypeId | null | undefined;
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payeeRelationshipId: string | null | undefined;
        payorId: string | null | undefined;
        q: string | null | undefined;
        isQuickpay: boolean | null | undefined;
        sessionCurrencyId: number | null | undefined;
        startDate: string | null | undefined;
        statusId: number[] | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        additionalDataItemField: string | null | undefined;
        factorCompanyId: string | null | undefined;
        isFactored: boolean | null | undefined;
        isDuplicate: boolean | null | undefined;
        excludeRemoved: boolean | null | undefined;
    }
    //
    export interface CorePayorInvoicesGetDraftTotalParams {
        date: string | null | undefined;
    }
    //
    export interface CorePayorInvoicesAutoSelectInvoicesToFinanceParams {
        dueDate: string | undefined;
        amountToFinance: number | null | undefined;
        payoutTermCode: string | null | undefined;
        invoiceIds: string[] | null | undefined;
    }
    //
    export interface CorePayorInvoicesGetInvoicesToFinanceParams {
        dueDate: string | undefined;
    }
    //
    export interface CorePayorInvoicesExportAutoSelectedInvoicesToFinanceParams {
        dueDate: string | undefined;
        amountToFinance: number | null | undefined;
        payoutTermCode: string | null | undefined;
        invoiceIds: string[] | null | undefined;
    }
    //
    export interface CorePayorInvoicesGetInvoiceStatusesParams {
        dateTypeId: SearchDateTypeId | null | undefined;
        endDate: string | null | undefined;
        startDate: string | null | undefined;
        payeeRelationshipId: string | null | undefined;
    }
    //
    export interface CorePayorInvoicesGetHeldInvoicesParams {
        q: string | null | undefined;
        scheduledPayDateStart: string | null | undefined;
        scheduledPayDateEnd: string | null | undefined;
        isQuickPay: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        heldByType: PayorInvoiceHoldReportHeldByType | null | undefined;
    }
    //
    export interface CorePayorLoadsSearchParams {
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payorId: string | null | undefined;
        payeeRelationshipId: string | null | undefined;
        q: string | null | undefined;
        sessionCurrencyId: number | null | undefined;
        startDate: string | null | undefined;
        statusId: number | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        additionalDataItemField: string | null | undefined;
    }
    //
    export interface CorePayorRelationshipCurrentRelationshipsParams {
        exportReport: boolean | undefined;
        q: string | null | undefined;
        externalPayeeKey: string | null | undefined;
        payorId: string | null | undefined;
        isQP: boolean | null | undefined;
        isPayeeSelectCarrier: boolean | null | undefined;
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        statusId: number[] | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        additionalDataItemField: string | null | undefined;
        factorCompanyId: string | null | undefined;
    }
    //
    export interface CorePayorRelationshipRelationshipNamesParams {
        payorId: string | null | undefined;
        q: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface CorePayorReportBillingReportParams {
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        q: string | null | undefined;
    }
    //
    export interface CorePayorReportBillingReportDetailsParams {
        startDate: string | null | undefined;
        id: string | null | undefined;
        batchId: string | null | undefined;
        exportReport: boolean | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface CorePayorReportSettlementStatementsParams {
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        settlementStatementTypeId: number[] | undefined;
        exportReport: boolean | undefined;
    }
    //
    export interface CorePayorReportFinancialAccountActivityParams {
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        exportReport: boolean | undefined;
    }
    //
    export interface CorePayorReportRelationship1099IncomeParams {
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        exportReport: boolean | undefined;
    }
    //
    export interface CorePayorReportInvoiceBatchReviewsParams {
        endDate: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        startDate: string | null | undefined;
    }
    //
    export interface CorePayorReportGotpFeesParams {
        page: number | null | undefined;
        pageSize: number | null | undefined;
    }
    //
    export interface CorePayorUnreconciledFundsGetUnreconciledFundsPayorTransactionsParams {
        endDate: string | null | undefined;
        exportReport: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        q: string | null | undefined;
        startDate: string | null | undefined;
    }
    //
    export interface CoreFactorPaymentsSearchPaymentsParams {
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        q: string | null | undefined;
        startDate: string | null | undefined;
        statusId: number | null | undefined;
        reportType: string | null | undefined;
        payeeName: string | null | undefined;
        payorName: string | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
    }
    //
    export interface CoreFactorPaymentsGetPaymentParams {
        exportReport: boolean | undefined;
        exportType: string | null | undefined;
    }
    //
    export interface CoreFactorPaymentsGetPaymentImagesParams {
        exportReport: boolean | undefined;
    }
    //
    export interface CoreFactorPayorsSearchCompaniesParams {
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        q: string | null | undefined;
        isInPaymentsNetwork: boolean | null | undefined;
        sessionCurrencyId: number | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        payorTypeId: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        includeIcons: boolean | null | undefined;
        exportReport: boolean | undefined;
    }
    //
    export interface CoreFactorPayorsSearchNamesParams {
        q: string | null | undefined;
        sessionCurrencyId: number | null | undefined;
        hasPaperwork: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface CorePayeeCreditNotesSearchParams {
        dateTypeId: SearchDateTypeId | null | undefined;
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payorId: string | null | undefined;
        payeeRelationshipId: string | null | undefined;
        sessionCurrencyId: number | null | undefined;
        q: string | null | undefined;
        startDate: string | null | undefined;
        statusId: number[] | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        additionalDataItemField: string | null | undefined;
    }
    //
    export interface CorePayeeInvoicesSearchInvoicesAndCreditNotesParams {
        dateTypeId: SearchDateTypeId | null | undefined;
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payeeRelationshipId: string[] | null | undefined;
        q: string | null | undefined;
        isQuickpay: boolean | null | undefined;
        sessionCurrencyId: number | null | undefined;
        startDate: string | null | undefined;
        statusId: number[] | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface CorePayeeInvoicesQpAvailableParams {
        shouldIncludeRelationshipsLackingInvoices: boolean | undefined;
    }
    //
    export interface CorePayeeInvoicesGetInvoiceStatusesParams {
        dateTypeId: SearchDateTypeId | null | undefined;
        endDate: string | null | undefined;
        startDate: string | null | undefined;
        payeeRelationshipId: string | null | undefined;
    }
    //
    export interface CorePayeeLoadsSearchParams {
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payorId: string | null | undefined;
        payeeRelationshipId: string | null | undefined;
        q: string | null | undefined;
        sessionCurrencyId: number | null | undefined;
        startDate: string | null | undefined;
        statusId: number | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        additionalDataItemField: string | null | undefined;
    }
    //
    export interface CorePayeePaymentsSearchPaymentsParams {
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payorId: string | null | undefined;
        payeeRelationshipId: string[] | null | undefined;
        q: string | null | undefined;
        sessionCurrencyId: number | null | undefined;
        startDate: string | null | undefined;
        statusId: number | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        factorCompanyId: string | null | undefined;
        isFactored: boolean | null | undefined;
        payoutTypeFilter: PayoutFilterTypeId | null | undefined;
    }
    //
    export interface CorePayeePaymentsGetPaymentParams {
        exportReport: boolean | undefined;
        exportType: string | null | undefined;
    }
    //
    export interface CorePayeePaymentsGetPaymentImagesParams {
        exportReport: boolean | undefined;
    }
    //
    export interface PublicPayeePayorsSearchCompaniesParams {
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        q: string | null | undefined;
        isInPaymentsNetwork: boolean | null | undefined;
        sessionCurrencyId: number | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        payorTypeId: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        includeIcons: boolean | null | undefined;
        exportReport: boolean | undefined;
    }
    //
    export interface PublicPayeePayorsSearchNamesParams {
        q: string | null | undefined;
        sessionCurrencyId: number | null | undefined;
        hasPaperwork: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface PublicPayeePayorsSearchNames2Params {
        q: string | null | undefined;
        sessionCurrencyId: number | null | undefined;
        hasPaperwork: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface CorePayeeRelationshipCurrentRelationshipsParams {
        exportReport: boolean | undefined;
        isQP: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        payorTypeId: number | null | undefined;
        payorId: string | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        sessionCurrencyId: number | null | undefined;
    }
    //
    export interface CorePayeeRelationshipUnclaimedRelationshipsParams {
        exportReport: boolean | undefined;
        isQP: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        payorTypeId: number | null | undefined;
        payorId: string | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        sessionCurrencyId: number | null | undefined;
    }
    //
    export interface CorePayeeRelationshipTakeControlInfoParams {
        token: string | null | undefined;
        email: string | null | undefined;
    }
    //
    export interface CorePayorPaymentsSearchPaymentsParams {
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payeeRelationshipId: string[] | null | undefined;
        q: string | null | undefined;
        sessionCurrencyId: number | null | undefined;
        startDate: string | null | undefined;
        statusId: number | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        factorCompanyId: string | null | undefined;
        isFactored: boolean | null | undefined;
        payoutTypeFilter: PayoutFilterTypeId | null | undefined;
        reportType: string | null | undefined;
    }
    //
    export interface CorePayorPaymentsGetPaymentParams {
        exportReport: boolean | undefined;
        exportType: string | null | undefined;
    }
    //
    export interface CorePayorPaymentsGetPaymentImagesParams {
        exportReport: boolean | undefined;
    }
    //
    export interface CoreAdminAdvanceGetAdvancePayorsParams {
        dateTypeId: SearchDateTypeId | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
    }
    //
    export interface CoreAdminAdvanceGetAdvancePayorParams {
        dateTypeId: SearchDateTypeId | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
    }
    //
    export interface CoreAdminAdvanceSummaryParams {
        payorId: string | null | undefined;
        relationshipId: string | null | undefined;
        scac: string | null | undefined;
        showCompletedOnly: boolean | null | undefined;
        dateTypeId: SearchDateTypeId | undefined;
    }
    //
    export interface CoreAdminBankListBanksParams {
        q: string | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        queue: BankReviewQueue | null | undefined;
        assignedTo: string[] | null | undefined;
        bankTypeId: number | null | undefined;
        carrierPacketFilter: boolean | null | undefined;
        exportReport: boolean | undefined;
    }
    //
    export interface CoreAdminBankClaimReviewItemParams {
        force: boolean | undefined;
    }
    //
    export interface CoreAdminBrokerAccountMatchingSearchParams {
        search: string | undefined;
    }
    //
    export interface CoreAdminBrokerAccountMatchingRandomParams {
        pageSize: number | undefined;
        cursor: string | null | undefined;
    }
    //
    export interface CoreAdminBrokerCarrierMatchingSearchParams {
        search: string | undefined;
    }
    //
    export interface CoreAdminBrokerCarrierMatchingRandomParams {
        source: string | null | undefined;
        pageSize: number | undefined;
        cursor: string | null | undefined;
    }
    //
    export interface CoreAdminBrokerCarrierMatchingRelationshipsParams {
        payorIds: string[] | undefined;
        externalPayeeKey: string | undefined;
    }
    //
    export interface CoreAdminCompanyGetCompanyDetailsParams {
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        isCompanyActive: boolean | null | undefined;
        companyTypeId: number | null | undefined;
        q: string | null | undefined;
    }
    //
    export interface CoreAdminDocumentListDocumentsParams {
        companyId: string | undefined;
        documentTypeId: number | undefined;
    }
    //
    export interface CoreAdminFactorAssignmentRequestListFactorAssignmentRequestsHistoryParams {
        globalCarrierId: string | null | undefined;
        isApproved: boolean | null | undefined;
        factorAssignmentRequestTypeId: number | null | undefined;
        auditFromDate: string | null | undefined;
        auditToDate: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        exportReport: boolean | undefined;
    }
    //
    export interface CoreAdminFactorMatchingSearchParams {
        search: string | undefined;
    }
    //
    export interface CoreAdminFactorMatchingRandomParams {
        pageSize: number | undefined;
        cursor: string | null | undefined;
    }
    //
    export interface CoreAdminFactorDebtorMatchingSearchParams {
        search: string | undefined;
    }
    //
    export interface CoreAdminFactorDebtorMatchingRandomParams {
        pageSize: number | undefined;
        cursor: string | null | undefined;
    }
    //
    export interface CoreAdminGlobalCarrierSearchGlobalCarriersParams {
        globalCarrierQuery: string | undefined;
    }
    //
    export interface CoreAdminGlobalCarrierGetGlobalCarrierFactorWillReleaseParams {
        globalCarrierGuid: string | undefined;
    }
    //
    export interface CoreAdminGlobalCarrierGetPayeeRelationshipsParams {
        globalCarrierId: string | undefined;
        factorCompanyId: string | null | undefined;
        payorCompanyId: string | null | undefined;
        fromLatestAssignmentDate: string | null | undefined;
        toLatestAssignmentDate: string | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface CoreAdminInvoiceListParams {
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        dateTypeId: SearchDateTypeId | undefined;
        fromDate: string | undefined;
        toDate: string | undefined;
        invoiceStatusId: number | null | undefined;
        payeeName: string | null | undefined;
        amount: number | null | undefined;
        payorName: string | null | undefined;
        invoiceNo: string | null | undefined;
        currencyTypeId: number | null | undefined;
        factorCompanyId: number | null | undefined;
        additionalDataItemField: string | null | undefined;
    }
    //
    export interface CoreAdminInvoiceExportParams {
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        dateTypeId: SearchDateTypeId | undefined;
        fromDate: string | undefined;
        toDate: string | undefined;
        invoiceStatusId: number | null | undefined;
        payeeName: string | null | undefined;
        amount: number | null | undefined;
        payorName: string | null | undefined;
        invoiceNo: string | null | undefined;
        currencyTypeId: number | null | undefined;
        factorCompanyId: number | null | undefined;
        additionalDataItemField: string | null | undefined;
    }
    //
    export interface CoreAdminJournalGetBalanceParams {
        date: string | undefined;
    }
    //
    export interface CoreAdminMetricsGetMetricAggregatesByDateRangeParams {
        minutesInPast: number | null | undefined;
    }
    //
    export interface CoreAdminMetricsGetIncomingNoaCountsParams {
        endDate: string | null | undefined;
    }
    //
    export interface CoreAdminMetricsGetMetricHistoryByIdAndDateRangeParams {
        hoursInPast: number | null | undefined;
    }
    //
    export interface CoreAdminMisdirectedPaymentMisdirectedPaymentsParams {
        fromDate: string | null | undefined;
        toDate: string | null | undefined;
        payorCompanyId: string | null | undefined;
        amount: number | null | undefined;
        paymentRecipient: string | null | undefined;
        transactionCode: string | null | undefined;
        reverseReasonId: number | null | undefined;
        payorTypeId: number | null | undefined;
        currencyTypeId: number | null | undefined;
        misdirectedPaymentTypeId: number | null | undefined;
        shouldHideCollectedFunds: boolean | undefined;
        exportReport: boolean | undefined;
    }
    //
    export interface CoreAdminNoaIndexParams {
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        shouldIncludeProcessedByCurrentUser: boolean | null | undefined;
        noaRequestStatusId: number | null | undefined;
        payorCompanyId: number | null | undefined;
        emailAddress: string | null | undefined;
        emailSubject: string | null | undefined;
        q: string | null | undefined;
        fromDate: string | null | undefined;
        toDate: string | null | undefined;
    }
    //
    export interface CoreAdminNoaTopCountsBySourceAddressParams {
        noaRequestStatusIds: number[] | null | undefined;
        sourceSubjectLine: string | null | undefined;
    }
    //
    export interface CoreAdminNoaCoachableIndexParams {
        incorrectUserId: string | null | undefined;
        sortField: string | null | undefined;
        exportReport: boolean | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        fromDate: string | null | undefined;
        toDate: string | null | undefined;
    }
    //
    export interface CoreAdminNoaIndex2Params {
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        isActionConflict: boolean | undefined;
        noaStatusIds: number[] | null | undefined;
        userEmail: string | null | undefined;
        flaggedForReviewOnly: boolean | undefined;
        factorId: string | null | undefined;
        payorId: string | null | undefined;
        reviewStatus: string | null | undefined;
        actionTaken: string | null | undefined;
        exportReport: boolean | undefined;
        payeeRelationshipIntId: number | null | undefined;
        payeeRelationshipGuid: string | null | undefined;
        payeeRelationshipIntIds: number[] | null | undefined;
        sourceSubject: string | null | undefined;
        sourceAddress: string | null | undefined;
        q: string | null | undefined;
        showSLA: boolean | null | undefined;
        exportFormatId: number | null | undefined;
        exportFilters: string | null | undefined;
        fromDate: string | null | undefined;
        toDate: string | null | undefined;
        dateRange: string | null | undefined;
        isDatesSet: boolean | undefined;
    }
    //
    export interface CoreAdminNoaSearchParams {
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        isActionConflict: boolean | undefined;
        noaStatusIds: number[] | null | undefined;
        userEmail: string | null | undefined;
        flaggedForReviewOnly: boolean | undefined;
        factorId: string | null | undefined;
        payorId: string | null | undefined;
        reviewStatus: string | null | undefined;
        actionTaken: string | null | undefined;
        exportReport: boolean | undefined;
        payeeRelationshipIntId: number | null | undefined;
        payeeRelationshipGuid: string | null | undefined;
        payeeRelationshipIntIds: number[] | null | undefined;
        sourceSubject: string | null | undefined;
        sourceAddress: string | null | undefined;
        q: string | null | undefined;
        showSLA: boolean | null | undefined;
        exportFormatId: number | null | undefined;
        exportFilters: string | null | undefined;
        fromDate: string | null | undefined;
        toDate: string | null | undefined;
        dateRange: string | null | undefined;
        isDatesSet: boolean | undefined;
    }
    //
    export interface CoreAdminNoaLockNoaRequestParams {
        shouldGetFirst: boolean | undefined;
        noaRequestStatusId: number | null | undefined;
    }
    //
    export interface CoreAdminNoaSearchNoaManagedPayorsParams {
        companyName: string | null | undefined;
    }
    //
    export interface CoreAdminNoaSearchRelationshipsParams {
        payorGuid: string | undefined;
        companyName: string | null | undefined;
    }
    //
    export interface CoreAdminNoaSearchFactorsParams {
        companyName: string | null | undefined;
    }
    //
    export interface CoreAdminNoaActionConflictIndexParams {
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        isActionConflict: boolean | undefined;
        noaStatusIds: number[] | null | undefined;
        userEmail: string | null | undefined;
        flaggedForReviewOnly: boolean | undefined;
        factorId: string | null | undefined;
        payorId: string | null | undefined;
        reviewStatus: string | null | undefined;
        actionTaken: string | null | undefined;
        exportReport: boolean | undefined;
        payeeRelationshipIntId: number | null | undefined;
        payeeRelationshipGuid: string | null | undefined;
        payeeRelationshipIntIds: number[] | null | undefined;
        sourceSubject: string | null | undefined;
        sourceAddress: string | null | undefined;
        q: string | null | undefined;
        showSLA: boolean | null | undefined;
        exportFormatId: number | null | undefined;
        exportFilters: string | null | undefined;
        fromDate: string | null | undefined;
        toDate: string | null | undefined;
        dateRange: string | null | undefined;
        isDatesSet: boolean | undefined;
    }
    //
    export interface CoreAdminPayeeListPayeesParams {
        mcNumber: string | undefined;
    }
    //
    export interface CoreAdminPayorListPayorsFullParams {
        q: string | null | undefined;
        includeInactive: boolean | null | undefined;
    }
    //
    export interface CoreAdminPayorSearchDeltaParams {
        q: string | undefined;
    }
    //
    export interface CoreAdminPayorListIncomingEftBankAccountParams {
        currencyTypeId: number | undefined;
    }
    //
    export interface CoreAdminPayorGetBankRequirementsParams {
        isDraft: boolean | undefined;
    }
    //
    export interface CoreAdminPromotionalCampaignListPromotionalCampaignsParams {
        endDate: string | null | undefined;
        exportReport: boolean | undefined;
        payorIds: string[] | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortAsc: boolean | null | undefined;
        sortField: string | null | undefined;
        startDate: string | null | undefined;
        statusId: number | null | undefined;
    }
    //
    export interface CoreAdminPromotionalCampaignListPromotionalCampaignRelationshipsParams {
        exportReport: boolean | undefined;
        payeeRelationshipIds: string[] | null | undefined;
        isQuickpayFeePaid: boolean | null | undefined;
        isQuickpayTermSelected: boolean | null | undefined;
        isRelationshipClaimed: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        q: string | null | undefined;
        sortAsc: boolean | null | undefined;
        sortField: string | null | undefined;
        statusId: number | null | undefined;
    }
    //
    export interface CoreAdminRelationshipListParams {
        exportReport: boolean | undefined;
        isClaimedRelationship: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
        showOnlyPayeeTerms: boolean | null | undefined;
        sessionCurrencyId: number | null | undefined;
        showPayorProvidedBankAccount: boolean | null | undefined;
        mCNumber: string | null | undefined;
        dOTNumber: string | null | undefined;
        payeeCompanyId: string | null | undefined;
    }
    //
    export interface CoreAdminReportCreditLimitExceededParams {
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        unacknowledgedOnly: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface CoreAdminReportInvoicePayeDateChangedParams {
        payorId: string | undefined;
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface CoreAdminReportInvoicePayeDateChanged2Params {
        payorId: string | undefined;
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface CoreAdminReportPayoutsOutOfBoundsParams {
        sinceDate: string | null | undefined;
    }
    //
    export interface CoreAdminReportListLoginsParams {
        q: string | null | undefined;
        sortField: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortAsc: boolean | null | undefined;
        exportFormatId: number | null | undefined;
        exportFilters: string | null | undefined;
        fromDate: string | null | undefined;
        toDate: string | null | undefined;
        dateRange: string | null | undefined;
        isDatesSet: boolean | undefined;
    }
    //
    export interface CoreAdminReportListImportExceptionsParams {
        topNRows: number | undefined;
        payorCompanyId: number | null | undefined;
        searchedEventLogTypeId: number | null | undefined;
        sortField: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortAsc: boolean | null | undefined;
        exportFormatId: number | null | undefined;
        exportFilters: string | null | undefined;
        fromDate: string | null | undefined;
        toDate: string | null | undefined;
        dateRange: string | null | undefined;
        isDatesSet: boolean | undefined;
    }
    //
    export interface CoreAdminReportPayoutReportParams {
        payeeRelationshipGuid: string | null | undefined;
    }
    //
    export interface CoreAdminSelectCarrierGetSelectCarriersParams {
        isSelfSelected: boolean | null | undefined;
        statusId: number | null | undefined;
        q: string | null | undefined;
        startDate: string | null | undefined;
        endDate: string | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        sortField: string | null | undefined;
        sortAsc: boolean | null | undefined;
    }
    //
    export interface CoreAdminTriumphLoadAdvanceGetAdvancePayorsParams {
        dateTypeId: SearchDateTypeId | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
    }
    //
    export interface CoreAdminTriumphLoadAdvanceGetAdvancePayorParams {
        dateTypeId: SearchDateTypeId | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
    }
    //
    export interface CoreAdminUnreconciledFundsGetUnreconciledFundsPayorsParams {
        exportReport: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        payorCompanyId: string | null | undefined;
    }
    //
    export interface CoreAdminUnreconciledFundsGetUnreconciledFundsPayorTransactionsParams {
        endDate: string | null | undefined;
        exportReport: boolean | null | undefined;
        page: number | null | undefined;
        pageSize: number | null | undefined;
        q: string | null | undefined;
        startDate: string | null | undefined;
        statusId: UnreconciledFundsStatusId | null | undefined;
    }
    //
    export interface CoreCsrSearchParams {
        payorId: string | null | undefined;
        carrierSearch: string | null | undefined;
        referenceNumber: string | null | undefined;
        usePayorId: boolean | undefined;
        useReferenceNumber: boolean | undefined;
        useCarrierSearch: boolean | undefined;
        pageSize: number | undefined;
        page: number | undefined;
    }
    //
    export interface CoreUnderwritingPayorExposuresParams {
        startDate: string | undefined;
        endDate: string | undefined;
    }
    //
export interface FeatureFlags {
    areNewRelationshipQuickpayRestrictionsEnabled: boolean;
    arePayorInsightsEnabled: boolean;
    isUsingFmcsaUserRegistration: boolean;
    isUsingHighRiskLorDesignationQueue: boolean;
    isPayorRemoveInvoiceFlowVisible: boolean;
    isGlobalLorFactorReleaseLowRiskEnabled: boolean;
    isNoaRejectReasonIgnoredEnabled: boolean;
    isUsingNewLogos: boolean;
    isUseNewPayeeWalletUI: boolean;
    isUsingNewPayorDashboard: boolean;
    spamButtonInNOAFlow: boolean;
    isTriumphLoadAdvancesEnabled: boolean;
}

export interface ListCompanyResponse {
    companies: ListCompanyResponseItem[];
}

export interface BaseTypeDtoOfInteger {
    id: number;
    name: string | null;
}

export interface TypeDto extends BaseTypeDtoOfInteger {
}

export interface ListCompanyResponseItem extends TypeDto {
    guid: string;
}

/** Base class for all Model objects. */
export interface BaseModel {
}

export interface PayorIntegrationDto extends BaseModel {
    id: string;
    division: string | null;
    spEmail: string | null;
    qpEmail: string | null;
    importInvoiceFolder: string | null;
    importLoadFolder: string | null;
    importRelationshipFolder: string | null;
    importCarrierPacketFolder: string | null;
    exportDraftFolder: string | null;
    exportPayoutFolder: string | null;
    exportRelationshipFolder: string | null;
    exportPaperworkFolder: string | null;
    exportPaperworkPassword: string | null;
    exportPaperworkUsername: string | null;
    exportPaperworkEncryptionKey: string | null;
    payorIntegrationExportPaperworkTypeId: number;
    payorIntegrationSendPaperworkEmail: boolean;
    exportPayeeBankInformationFolder: string | null;
}

export interface TokenResponse {
    token: string;
}

export interface LoginResponse extends TokenResponse {
    user: UserDto;
    alertMessage: string;
}

export interface UserDto extends BaseModel {
    availableCompanies: CompanyDto[] | null;
    company: CompanyDto | null;
    email: string | null;
    id: string | null;
    name: string | null;
    factorDetails: UserFactorDetailsDto | null;
    payeeDetails: UserPayeeDetailsDto | null;
    payorDetails: UserPayorDetailsDto | null;
    phoneNumber: string | null;
    missingDetails: UserMissingDetailsDto | null;
    roles: TypeDto[] | null;
    hasActiveAPIIntegrationToken: boolean;
}

export interface CompanyDto {
    bankAccounts: BankAccountDto[];
    dotNumber: string | null;
    id: string | null;
    mcNumber: string | null;
    name: string;
    scac: string | null;
    type: TypeDto;
    displayName: string | null;
}

export interface BankAccountDto {
    address: AddressDto | null;
    bankAccountType: BankAccountTypeDto;
    createdOn: string | null;
    currencyType: TypeDto;
    id: string;
    name: string;
    shortName: string;
    status: TypeDto;
    beneficiaryName: string | null;
}

export interface AddressDto {
    addr1: string | null;
    addr2: string | null;
    addr3: string | null;
    city: string | null;
    state: string | null;
    postalCode: string | null;
    country: string | null;
}

export interface BankAccountTypeDto extends TypeDto {
    paymentFee: number | null;
}

export interface UserFactorDetailsDto {
    showCSVReport: boolean;
    preventCopyPasteInSearch: boolean;
    isNetworkFactor: boolean;
    useAllLoadsSearch: boolean;
    useLoadCsTicket: boolean;
    useAllInvoicesSearch: boolean;
    disableInvoiceReportExport: boolean;
    disableLoadReportExport: boolean;
    disablePaymentReportExport: boolean;
    useInvoiceCsTicket: boolean;
}

export interface UserPayeeDetailsDto {
    isRateAccepted: boolean;
    selectCarrierRate: number | null;
    isPayeeHeld: boolean;
    statusNote: string | null;
}

export interface UserPayorDetailsDto {
    isOperationsNoBuy: boolean;
    canReleaseInvoices: boolean;
    isHighwaySubscriber: boolean;
    isEftPayor: boolean;
    isInternational: boolean;
    currency: string;
    payorTypeId: number | null;
    showGotpFeesReport: boolean;
}

export interface UserMissingDetailsDto {
    isPasswordMissing: boolean;
    mfaMethod: boolean;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateSessionRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateSessionRequest extends BaseModelOfUpdateSessionRequestAndTriumphPayEntities {
}

export interface UpdateSessionRequest extends CoreAPIRequestBaseOfUpdateSessionRequest {
    companyId: number | null;
    companyGuid: string | null;
}

export interface GetSegmentsResponse {
    segments: string[];
}

export interface CountriesResponse {
    countries: CountryDto[];
}

export interface CountryDto {
    alpha2Code: Alpha2Code;
    alpha3Code: Alpha3Code;
    commonName: string;
    nativeName: string;
}

/** Alpha2 code (ISO-3166-1) */
export enum Alpha2Code {
    AF = 0,
    AX = 1,
    AL = 2,
    DZ = 3,
    AS = 4,
    AD = 5,
    AO = 6,
    AI = 7,
    AQ = 8,
    AG = 9,
    AR = 10,
    AM = 11,
    AW = 12,
    AU = 13,
    AT = 14,
    AZ = 15,
    BS = 16,
    BH = 17,
    BD = 18,
    BB = 19,
    BY = 20,
    BE = 21,
    BZ = 22,
    BJ = 23,
    BM = 24,
    BT = 25,
    BO = 26,
    BQ = 27,
    BA = 28,
    BW = 29,
    BV = 30,
    BR = 31,
    IO = 32,
    BN = 33,
    BG = 34,
    BF = 35,
    BI = 36,
    KH = 37,
    CM = 38,
    CA = 39,
    CV = 40,
    KY = 41,
    CF = 42,
    TD = 43,
    CL = 44,
    CN = 45,
    CX = 46,
    CC = 47,
    CO = 48,
    KM = 49,
    CG = 50,
    CD = 51,
    CK = 52,
    CR = 53,
    CI = 54,
    HR = 55,
    CU = 56,
    CW = 57,
    CY = 58,
    CZ = 59,
    DK = 60,
    DJ = 61,
    DM = 62,
    DO = 63,
    EC = 64,
    EG = 65,
    SV = 66,
    GQ = 67,
    ER = 68,
    EE = 69,
    ET = 70,
    FK = 71,
    FO = 72,
    FJ = 73,
    FI = 74,
    FR = 75,
    GF = 76,
    PF = 77,
    TF = 78,
    GA = 79,
    GM = 80,
    GE = 81,
    DE = 82,
    GH = 83,
    GI = 84,
    GR = 85,
    GL = 86,
    GD = 87,
    GP = 88,
    GU = 89,
    GT = 90,
    GG = 91,
    GN = 92,
    GW = 93,
    GY = 94,
    HT = 95,
    HM = 96,
    HN = 97,
    HK = 98,
    HU = 99,
    IS = 100,
    IN = 101,
    ID = 102,
    IR = 103,
    IQ = 104,
    IE = 105,
    IM = 106,
    IL = 107,
    IT = 108,
    JM = 109,
    JP = 110,
    JE = 111,
    JO = 112,
    KZ = 113,
    KE = 114,
    KI = 115,
    KP = 116,
    KR = 117,
    KW = 118,
    KG = 119,
    LA = 120,
    LV = 121,
    LB = 122,
    LS = 123,
    LR = 124,
    LY = 125,
    LI = 126,
    LT = 127,
    LU = 128,
    MO = 129,
    MK = 130,
    MG = 131,
    MW = 132,
    MY = 133,
    MV = 134,
    ML = 135,
    MT = 136,
    MH = 137,
    MQ = 138,
    MR = 139,
    MU = 140,
    YT = 141,
    MX = 142,
    FM = 143,
    MD = 144,
    MC = 145,
    MN = 146,
    ME = 147,
    MS = 148,
    MA = 149,
    MZ = 150,
    MM = 151,
    NA = 152,
    NR = 153,
    NP = 154,
    NL = 155,
    NC = 156,
    NZ = 157,
    NI = 158,
    NE = 159,
    NG = 160,
    NU = 161,
    NF = 162,
    MP = 163,
    NO = 164,
    OM = 165,
    PK = 166,
    PW = 167,
    PS = 168,
    PA = 169,
    PG = 170,
    PY = 171,
    PE = 172,
    PH = 173,
    PN = 174,
    PL = 175,
    PT = 176,
    PR = 177,
    QA = 178,
    RE = 179,
    RO = 180,
    RU = 181,
    RW = 182,
    BL = 183,
    SH = 184,
    KN = 185,
    LC = 186,
    MF = 187,
    PM = 188,
    VC = 189,
    WS = 190,
    SM = 191,
    ST = 192,
    SA = 193,
    SN = 194,
    RS = 195,
    SC = 196,
    SL = 197,
    SG = 198,
    SX = 199,
    SK = 200,
    SI = 201,
    SB = 202,
    SO = 203,
    ZA = 204,
    GS = 205,
    SS = 206,
    ES = 207,
    LK = 208,
    SD = 209,
    SR = 210,
    SJ = 211,
    SZ = 212,
    SE = 213,
    CH = 214,
    SY = 215,
    TW = 216,
    TJ = 217,
    TZ = 218,
    TH = 219,
    TL = 220,
    TG = 221,
    TK = 222,
    TO = 223,
    TT = 224,
    TN = 225,
    TR = 226,
    TM = 227,
    TC = 228,
    TV = 229,
    UG = 230,
    UA = 231,
    AE = 232,
    GB = 233,
    UM = 234,
    US = 235,
    UY = 236,
    UZ = 237,
    VU = 238,
    VA = 239,
    VE = 240,
    VN = 241,
    VG = 242,
    VI = 243,
    WF = 244,
    EH = 245,
    YE = 246,
    ZM = 247,
    ZW = 248,
}

/** Alpha3 code (ISO-3166-1) */
export enum Alpha3Code {
    AFG = 0,
    ALA = 1,
    ALB = 2,
    DZA = 3,
    ASM = 4,
    AND = 5,
    AGO = 6,
    AIA = 7,
    ATA = 8,
    ATG = 9,
    ARG = 10,
    ARM = 11,
    ABW = 12,
    AUS = 13,
    AUT = 14,
    AZE = 15,
    BHS = 16,
    BHR = 17,
    BGD = 18,
    BRB = 19,
    BLR = 20,
    BEL = 21,
    BLZ = 22,
    BEN = 23,
    BMU = 24,
    BTN = 25,
    BOL = 26,
    BES = 27,
    BIH = 28,
    BWA = 29,
    BVT = 30,
    BRA = 31,
    IOT = 32,
    BRN = 33,
    BGR = 34,
    BFA = 35,
    BDI = 36,
    KHM = 37,
    CMR = 38,
    CAN = 39,
    CPV = 40,
    CYM = 41,
    CAF = 42,
    TCD = 43,
    CHL = 44,
    CHN = 45,
    CXR = 46,
    CCK = 47,
    COL = 48,
    COM = 49,
    COG = 50,
    COD = 51,
    COK = 52,
    CRI = 53,
    CIV = 54,
    HRV = 55,
    CUB = 56,
    CUW = 57,
    CYP = 58,
    CZE = 59,
    DNK = 60,
    DJI = 61,
    DMA = 62,
    DOM = 63,
    ECU = 64,
    EGY = 65,
    SLV = 66,
    GNQ = 67,
    ERI = 68,
    EST = 69,
    ETH = 70,
    FLK = 71,
    FRO = 72,
    FJI = 73,
    FIN = 74,
    FRA = 75,
    GUF = 76,
    PYF = 77,
    ATF = 78,
    GAB = 79,
    GMB = 80,
    GEO = 81,
    DEU = 82,
    GHA = 83,
    GIB = 84,
    GRC = 85,
    GRL = 86,
    GRD = 87,
    GLP = 88,
    GUM = 89,
    GTM = 90,
    GGY = 91,
    GIN = 92,
    GNB = 93,
    GUY = 94,
    HTI = 95,
    HMD = 96,
    HND = 97,
    HKG = 98,
    HUN = 99,
    ISL = 100,
    IND = 101,
    IDN = 102,
    IRN = 103,
    IRQ = 104,
    IRL = 105,
    IMN = 106,
    ISR = 107,
    ITA = 108,
    JAM = 109,
    JPN = 110,
    JEY = 111,
    JOR = 112,
    KAZ = 113,
    KEN = 114,
    KIR = 115,
    PRK = 116,
    KOR = 117,
    KWT = 118,
    KGZ = 119,
    LAO = 120,
    LVA = 121,
    LBN = 122,
    LSO = 123,
    LBR = 124,
    LBY = 125,
    LIE = 126,
    LTU = 127,
    LUX = 128,
    MAC = 129,
    MKD = 130,
    MDG = 131,
    MWI = 132,
    MYS = 133,
    MDV = 134,
    MLI = 135,
    MLT = 136,
    MHL = 137,
    MTQ = 138,
    MRT = 139,
    MUS = 140,
    MYT = 141,
    MEX = 142,
    FSM = 143,
    MDA = 144,
    MCO = 145,
    MNG = 146,
    MNE = 147,
    MSR = 148,
    MAR = 149,
    MOZ = 150,
    MMR = 151,
    NAM = 152,
    NRU = 153,
    NPL = 154,
    NLD = 155,
    NCL = 156,
    NZL = 157,
    NIC = 158,
    NER = 159,
    NGA = 160,
    NIU = 161,
    NFK = 162,
    MNP = 163,
    NOR = 164,
    OMN = 165,
    PAK = 166,
    PLW = 167,
    PSE = 168,
    PAN = 169,
    PNG = 170,
    PRY = 171,
    PER = 172,
    PHL = 173,
    PCN = 174,
    POL = 175,
    PRT = 176,
    PRI = 177,
    QAT = 178,
    REU = 179,
    ROU = 180,
    RUS = 181,
    RWA = 182,
    BLM = 183,
    SHN = 184,
    KNA = 185,
    LCA = 186,
    MAF = 187,
    SPM = 188,
    VCT = 189,
    WSM = 190,
    SMR = 191,
    STP = 192,
    SAU = 193,
    SEN = 194,
    SRB = 195,
    SYC = 196,
    SLE = 197,
    SGP = 198,
    SXM = 199,
    SVK = 200,
    SVN = 201,
    SLB = 202,
    SOM = 203,
    ZAF = 204,
    SGS = 205,
    SSD = 206,
    ESP = 207,
    LKA = 208,
    SDN = 209,
    SUR = 210,
    SJM = 211,
    SWZ = 212,
    SWE = 213,
    CHE = 214,
    SYR = 215,
    TWN = 216,
    TJK = 217,
    TZA = 218,
    THA = 219,
    TLS = 220,
    TGO = 221,
    TKL = 222,
    TON = 223,
    TTO = 224,
    TUN = 225,
    TUR = 226,
    TKM = 227,
    TCA = 228,
    TUV = 229,
    UGA = 230,
    UKR = 231,
    ARE = 232,
    GBR = 233,
    UMI = 234,
    USA = 235,
    URY = 236,
    UZB = 237,
    VUT = 238,
    VAT = 239,
    VEN = 240,
    VNM = 241,
    VGB = 242,
    VIR = 243,
    WLF = 244,
    ESH = 245,
    YEM = 246,
    ZMB = 247,
    ZWE = 248,
}

export interface FileDto {
    fileData: string;
    fileName: string;
}

export interface GetProviderNameResponse {
    providerName: string;
}

export interface UserResponse {
    user: UserDto;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfLoginRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfLoginRequest extends BaseModelOfLoginRequestAndTriumphPayEntities {
}

export interface LoginRequest extends CoreAPIRequestBaseOfLoginRequest {
    username: string | null;
    password: string | null;
    token: string | null;
    tokenType: string | null;
    newPassword: string | null;
    confirmNewPassword: string | null;
    mfaCode: string | null;
    deviceId: string | null;
    mobileAppVersion: string | null;
    apiKey: string;
    apiSecret: string;
    signatureInCookie: boolean;
    captchaToken: string | null;
}

export interface SsoTokenResponse {
    ssoToken: string;
}

export interface RefreshTokenResponse {
    refreshToken: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfRefreshTokenRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfRefreshTokenRequest extends BaseModelOfRefreshTokenRequestAndTriumphPayEntities {
}

export interface RefreshTokenRequest extends CoreAPIRequestBaseOfRefreshTokenRequest {
    guid: string | null;
    mcleod: boolean | null;
}

export interface RegistrationCodeResponse {
    user: UserDto;
    isNewSignupFlowUsed: boolean;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfRegistrationCodeRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfRegistrationCodeRequest extends BaseModelOfRegistrationCodeRequestAndTriumphPayEntities {
}

export interface RegistrationCodeRequest extends CoreAPIRequestBaseOfRegistrationCodeRequest {
    apiKey: string;
    apiSecret: string;
    code: string;
    payeeRelationshipId: string;
}

export interface SuccessResponse {
    success: boolean;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfForwardRegistrationRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfForwardRegistrationRequest extends BaseModelOfForwardRegistrationRequestAndTriumphPayEntities {
}

export interface ForwardRegistrationRequest extends CoreAPIRequestBaseOfForwardRegistrationRequest {
    apiKey: string;
    apiSecret: string;
    code: string;
    payeeRelationshipId: string;
    recipient: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfRequestPasswordResetRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfRequestPasswordResetRequest extends BaseModelOfRequestPasswordResetRequestAndTriumphPayEntities {
}

export interface AbstractUnauthenticatedUserRequestOfRequestPasswordResetRequest extends CoreAPIRequestBaseOfRequestPasswordResetRequest {
    email: string;
}

export interface RequestPasswordResetRequest extends AbstractUnauthenticatedUserRequestOfRequestPasswordResetRequest {
}

export interface AuthorizedRequestPasswordResetResponse {
    success: boolean;
    isTempPasswordCreated: boolean;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfAuthorizedRequestPasswordResetRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfAuthorizedRequestPasswordResetRequest extends BaseModelOfAuthorizedRequestPasswordResetRequestAndTriumphPayEntities {
}

export interface AuthorizedRequestPasswordResetRequest extends CoreAPIRequestBaseOfAuthorizedRequestPasswordResetRequest {
    userGuid: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfMfaRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfMfaRequest extends BaseModelOfMfaRequestAndTriumphPayEntities {
}

export interface AbstractUnauthenticatedUserRequestOfMfaRequest extends CoreAPIRequestBaseOfMfaRequest {
    email: string;
}

export interface MfaRequest extends AbstractUnauthenticatedUserRequestOfMfaRequest {
    overrideMfaTypeId: number | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfResetPasswordRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfResetPasswordRequest extends BaseModelOfResetPasswordRequestAndTriumphPayEntities {
}

export interface ResetPasswordRequest extends CoreAPIRequestBaseOfResetPasswordRequest {
    confirmPassword: string;
    password: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateSessionRequestAndTriumphPayEntities2 extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateSessionRequest2 extends BaseModelOfUpdateSessionRequestAndTriumphPayEntities2 {
}

export interface UpdateSessionRequest2 extends CoreAPIRequestBaseOfUpdateSessionRequest2 {
    companyId: string;
}

export interface TokenExpirationResponse {
    csrfToken: string;
    seconds: number;
}

export interface OktaLoginTypeResponse extends BaseModel {
    issuer: string | null;
    redirectUri: string | null;
    clientId: string | null;
    isOIE: boolean;
    oktaTenantId: number | null;
    captcha: CaptchaTypeResponse | null;
}

export interface CaptchaTypeResponse extends BaseModel {
    isCaptchaRequired: boolean;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpgradeOktaTokenRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpgradeOktaTokenRequest extends BaseModelOfUpgradeOktaTokenRequestAndTriumphPayEntities {
}

export interface UpgradeOktaTokenRequest extends CoreAPIRequestBaseOfUpgradeOktaTokenRequest {
    oktaClientId: string | null;
    oktaTenantId: number | null;
    oktaToken: string;
    signatureInCookie: boolean;
    apiKey: string;
    apiSecret: string;
    isMobile: boolean | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfCaptchaRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfCaptchaRequest extends BaseModelOfCaptchaRequestAndTriumphPayEntities {
}

export interface CaptchaRequest extends CoreAPIRequestBaseOfCaptchaRequest {
    username: string | null;
    captchaToken: string | null;
}

export interface MultiFactorResetResponse {
    success: boolean;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfMultiFactorResetRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfMultiFactorResetRequest extends BaseModelOfMultiFactorResetRequestAndTriumphPayEntities {
}

export interface MultiFactorResetRequest extends CoreAPIRequestBaseOfMultiFactorResetRequest {
    userGuid: string;
}

export interface OAuthInfoResponse {
    providerLogo: string | null;
    providerName: string | null;
    providerText: string | null;
}

export interface GenerateRedirectResponse {
    redirectUrl: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfOAuthRequestModelAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfOAuthRequestModel extends BaseModelOfOAuthRequestModelAndTriumphPayEntities {
}

export interface OAuthRequestModel extends CoreAPIRequestBaseOfOAuthRequestModel {
    access_type: string | null;
    client_id: string;
    redirect_uri: string;
    response_type: string;
    scope: string;
    state: string | null;
    triumphCompanyId: string | null;
}

export interface DataAccessObjectBaseOfTriumphPayEntities {
}

export interface PushNotificationDevice extends DataAccessObjectBaseOfTriumphPayEntities {
    id: number;
    companyId: number;
    userGuid: string;
    deviceId: string | null;
    appVersion: string | null;
    os: string | null;
    osVersion: string | null;
    registrationToken: string | null;
    lastUpdatedDateTime: string;
}

export interface PayeePushNotificationDeviceRequest {
    appVersion: string;
    os: string;
    osVersion: string;
    registrationToken: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfSubscriptionRequestAndTriumphPayEntities extends BaseModel {
}

export interface SubscriptionRequest extends BaseModelOfSubscriptionRequestAndTriumphPayEntities {
    subscriptions: string[];
}

export interface GetSelectCarrierDefaultRateResponse {
    defaultRate: string;
}

export interface UsersResponse {
    users: UserDto[];
}

export interface ListUserRolesResponse {
    userRoles: TypeDescriptionDto[];
}

export interface TypeDescriptionDto extends TypeDto {
    description: string | null;
}

export interface ListUserNotificationsResponse {
    notifications: NotificationTypeDto[];
}

export interface NotificationTypeDto extends TypeDto {
    description: string;
    availableTransmissionTypes: TypeDto[] | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfCreateUserRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfCreateUserRequest extends BaseModelOfCreateUserRequestAndTriumphPayEntities {
}

export interface CreateUserRequest extends CoreAPIRequestBaseOfCreateUserRequest {
    email: string;
    name: string;
    notifications: NotificationRequest[] | null;
    phoneNumber: string;
    roleIds: number[];
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfNotificationRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfNotificationRequest extends BaseModelOfNotificationRequestAndTriumphPayEntities {
}

export interface NotificationRequest extends CoreAPIRequestBaseOfNotificationRequest {
    notificationTypeId: number;
    transmissionTypeIds: number[];
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateUserRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateUserRequest extends BaseModelOfUpdateUserRequestAndTriumphPayEntities {
}

export interface UpdateUserRequest extends CoreAPIRequestBaseOfUpdateUserRequest {
    email: string | null;
    name: string | null;
    notifications: NotificationRequest[] | null;
    phoneNumber: string | null;
    roleIds: number[] | null;
    confirmPassword: string | null;
    currentPassword: string | null;
    password: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateMfaTypeRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateMfaTypeRequest extends BaseModelOfUpdateMfaTypeRequestAndTriumphPayEntities {
}

export interface UpdateMfaTypeRequest extends CoreAPIRequestBaseOfUpdateMfaTypeRequest {
    code: string;
    deviceId: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUnlockUserRequestAndTriumphPayEntities extends BaseModel {
}

export interface UnlockUserRequest extends BaseModelOfUnlockUserRequestAndTriumphPayEntities {
    emailAddress: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfSendUserCodeRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfSendUserCodeRequest extends BaseModelOfSendUserCodeRequestAndTriumphPayEntities {
}

export interface SendUserCodeRequest extends CoreAPIRequestBaseOfSendUserCodeRequest {
    email: string;
}

export interface VerifyUserCodeResponse {
    emailExists: boolean;
    carrierCompanyRequired: boolean;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfVerifyUserCodeRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfVerifyUserCodeRequest extends BaseModelOfVerifyUserCodeRequestAndTriumphPayEntities {
}

export interface VerifyUserCodeRequest extends CoreAPIRequestBaseOfVerifyUserCodeRequest {
    email: string;
    verificationCode: string;
}

export interface UserNotificationResponse {
    notificationTypeId: number;
    transmissionTypeIds: number[];
}

export interface FactorDashboardResponse {
    acceptedTermsOfService: boolean;
}

export interface SearchFactorInvoicesBasicResponse {
    invoices: FactorInvoiceDto[];
}

export interface FactorInvoiceDto {
    approvedDate: string | null;
    id: string;
    invoiceNo: string | null;
    referenceNo: string | null;
    namedReferenceNumbers: ReferenceNumberModel[] | null;
    referenceNos: string[] | null;
    netAmountAfterPayeeTermFee: number;
    payor: PayorBasicDto | null;
    payeeRelationship: GuidDto | null;
    scheduledPaymentDate: string | null;
    status: StatusTypeDto | null;
    uploadedDate: string;
}

export interface ReferenceNumberModel {
    description: string | null;
    value: string | null;
}

export interface GuidDto extends BaseModel {
    id: string;
    name: string | null;
}

export interface PayorBasicDto extends GuidDto {
    currencyType: TypeDto | null;
}

export interface StatusTypeDto extends TypeDto {
    dateChanged: string | null;
    note: string | null;
}

export enum SearchDateTypeId {
    DateUploaded = 1,
    DateApproved = 2,
    DatePaid = 3,
    DateApprovedSet = 4,
    DateDrafted = 5,
    DateStatusChange = 6,
    DateAdvanceScheduled = 7,
    DateInvoiceRequested = 8,
    DatePaymentScheduled = 9,
}

export interface InvoiceResponse {
    invoice: InvoiceDto;
}

export interface InvoiceDto extends BaseModel {
    actualDraftDate: string | null;
    advancePayeePercentageFee: number | null;
    approvedDate: string | null;
    creditNoteApplicationAmount: number;
    availablePaymentTerms: PaymentTermDto[] | null;
    creditNotes: CreditNoteBasicApplicationDto[] | null;
    grossAmount: number;
    highwayDetails: HighwayDetailsDTO | null;
    id: string;
    invoiceNo: string | null;
    isAdvance: boolean;
    isPaymentTermEditable: boolean;
    /** Indicates if this invoice is removable. */
    isRemovable: boolean | null;
    /** Indicates if the current user is allowed to remove invoices.
This value can differ from IsRemovable. */
    isRemovableByUser: boolean;
    isInvoiceOrRelationshipHeldByPayorSystem: boolean;
    isRelationshipHeld: boolean;
    isTermFeesRefunded: boolean;
    lineItems: LineItemDto[] | null;
    triumphLoadAdvancePayment: PaymentDto | null;
    namedReferenceNumbers: ReferenceNumberModel[] | null;
    netAmount: number;
    netAmountAfterPayeeTermFee: number;
    payeeRelationship: GuidDto | null;
    payment: PaymentDto | null;
    paymentTerm: PaymentTermDto | null;
    payor: PayorBasicDto | null;
    payorHasIncomingEftBankAccount: boolean | null;
    factor: GuidDto | null;
    referenceNos: string[] | null;
    refundedTermFeePayoutId: string | null;
    payorRequestedPaymentDate: string | null;
    draftId: number | null;
    scheduledDraftDate: string | null;
    scheduledPaymentDate: string | null;
    isMissingEft: boolean;
    status: StatusTypeDto | null;
    exportStatusId: number | null;
    statusChangeDate: string | null;
    uploadedDate: string;
    hasPromotionalInvoice: boolean;
    willPayToRealTimePayableBankAccount: boolean;
    activeHolds: ActiveHoldDto[] | null;
}

export interface PaymentTermDto {
    disabledReason: string | null;
    daysToPay: number;
    id: string;
    isQuickPay: boolean;
    flatFee: number;
    name: string;
    percentageFee: number;
    payeeTermFee: number | null;
    payorComissionFlat: number | null;
    payorComissionPercentage: number | null;
    payorFlatFee: number | null;
    payorPercentageFee: number | null;
    isFeeAdjusted: boolean;
    originalPercentageFee: number;
    financePeriod: number | null;
    payoutTermTypeId: PayoutTermTypeId;
}

export enum PayoutTermTypeId {
    StandardPay = 1,
    QuickPay = 2,
    GuaranteedOnTimePay = 3,
}

export interface CreditNoteBasicApplicationDto {
    amount: number;
    creditNoteId: string;
    referenceNo: string | null;
}

export interface HighwayDetailsDTO {
    identityAlertsCount: number;
    fraudIndicatorLevel: TypeDto;
}

export interface LineItemDto {
    amount: number;
    description: string;
    invoiceLineItemId: number | null;
    payoutGuid: string | null;
}

export interface PaymentDto {
    bankAccount: BankAccountDto;
    creditNoteApplications: PayoutCreditNoteDTO[] | null;
    cashedCheckImageThumbnails: string[] | null;
    confirmationCode: string;
    id: string;
    invoices: InvoiceDto[] | null;
    /** For a Triumph Load Advance payment, this will be the invoices that were used to recourse the load advance.
Initially this will be empty for the payout and over time as invoices are created, these will be populated.
This a distinctly different relationship than the other Invoices property. */
    triumphLoadAdvanceInvoices: InvoiceDto[] | null;
    paidDate: string | null;
    payeeRelationship: GuidDto | null;
    paymentFee: number;
    payor: PayorBasicDto | null;
    status: TypeDto;
    totalPaymentAmount: number;
    transactionCode: string | null;
    hasPromotionalInvoice: boolean;
    isLoadAdvance: boolean;
    payoutTypeId: EnumTypeDtoOfPayoutTypeId;
    invoiceTypeId: EnumTypeDtoOfInvoiceTypeId | null;
    loadIds: string[] | null;
}

export interface PayoutCreditNoteDTO {
    amount: number;
    creditNote: CreditNoteDto;
}

export interface CreditNoteDto extends BaseModel {
    creditDate: string;
    dateChanged: string;
    grossAmount: number;
    id: string;
    outstandingAmount: number;
    paidInFullDate: string | null;
    payeeRelationship: GuidDto | null;
    paymentApplications: CreditNoteApplicationDto[] | null;
    payor: PayorBasicDto | null;
    namedReferenceNumbers: ReferenceNumberModel[] | null;
    referenceNo: string;
    status: StatusTypeDto;
    uploadedDate: string;
    invoiceNo: string | null;
}

export interface CreditNoteApplicationDto {
    amount: number;
    confirmationCode: string | null;
    draftDate: string | null;
    invoiceId: string;
    invoiceNo: string | null;
    paymentId: string | null;
    paidDate: string | null;
    transactionCode: string | null;
}

export interface BaseTypeDtoOfPayoutTypeId {
    id: PayoutTypeId;
    name: string | null;
}

export interface EnumTypeDtoOfPayoutTypeId extends BaseTypeDtoOfPayoutTypeId {
}

export enum PayoutTypeId {
    LEGACY_PAYOUT = 1,
    INVOICE_PAYOUT = 2,
    SHIPPER_ADVANCE_PAYOUT = 3,
    TERM_FEE_REFUND = 4,
    QUICKPAY_INVOICE_PAYOUT = 5,
    ADVANCED_INVOICE_PAYOUT = 6,
    PROMOTIONAL_QUICKPAY_INVOICE_PAYOUT = 7,
    BROKER_LOAD_ADVANCE_PAYOUT = 8,
    TRIUMPH_LOAD_ADVANCE_PAYOUT = 9,
}

export interface BaseTypeDtoOfInvoiceTypeId {
    id: InvoiceTypeId;
    name: string | null;
}

export interface EnumTypeDtoOfInvoiceTypeId extends BaseTypeDtoOfInvoiceTypeId {
}

export enum InvoiceTypeId {
    Standard = "Standard",
    Factored = "Factored",
    AdvancedFull = "AdvancedFull",
    BrokerLoadAdvance = "LoadAdvance",
}

export interface ActiveHoldDto {
    createdDateTime: string;
    holdLevel: string;
    holdMessage: string | null;
    holdPlacedByType: string;
    holdReason: string;
    invoicesHeldCount: number;
    paymentsHeldAmount: number;
    isAbleToRelease: boolean;
    overdueInvoicesHeldCount: number | null;
}

export interface BaseTypeDtoOfInvoiceStatusId {
    id: InvoiceStatusId;
    name: string | null;
}

export interface EnumTypeDtoOfInvoiceStatusId extends BaseTypeDtoOfInvoiceStatusId {
}

export enum InvoiceStatusId {
    Pending = 1,
    Approved = 2,
    Paid = 3,
    Held = 5,
    MissingCarrier = 6,
    Removed = 8,
    PendingReissue = 10,
    MissingBank = 11,
    Refunded = 12,
}

export interface InvoiceDateTypesResponse {
    invoiceDateTypes: EnumTypeDtoOfSearchDateTypeId[];
}

export interface BaseTypeDtoOfSearchDateTypeId {
    id: SearchDateTypeId;
    name: string | null;
}

export interface EnumTypeDtoOfSearchDateTypeId extends BaseTypeDtoOfSearchDateTypeId {
}

export interface SubmitCsTicketResponse {
    emailSentTo: string;
}

export interface SubmitCsTicketRequest {
    reasons: CsTicketReason[];
    loadGuid: string | null;
    referenceNumber: string | null;
    payorCompanyGuid: string;
    payeeRelationshipGuid: string | null;
    details: string | null;
    payeeSearch: string | null;
}

export enum CsTicketReason {
    CreditNoteIssue = 1,
    IncorrectAmount = 2,
    NotFound = 3,
    MisdirectedPayment = 4,
    NoaLorDiscrepancy = 5,
    PaymentDelay = 6,
    Other = 7,
}

export interface SearchLoadsResponse {
    loads: LoadDto[];
}

export interface LoadDto {
    delivery: RoutePointDto;
    distance: DistanceDto | null;
    id: string;
    lineItems: LineItemDto[] | null;
    namedReferenceNumbers: ReferenceNumberModel[] | null;
    netAmount: number | null;
    payeeRelationship: GuidDto | null;
    payor: PayorBasicDto;
    pickUp: RoutePointDto;
    referenceNo: string;
    status: TypeDto;
    uploadedDate: string | null;
    factor: GuidDto | null;
    isPaymentsNetworkLoad: boolean | null;
}

export interface RoutePointDto {
    date: string | null;
    address: AddressDto | null;
}

export interface DistanceDto {
    unit: TypeDto;
    value: number;
}

export interface LoadResponse {
    load: LoadDto;
}

export interface LoadStatusResponse {
    loadStatuses: TypeDto[];
}

export interface LoadsDateTypesResponse {
    loadsDateTypes: EnumTypeDtoOfSearchDateTypeId[];
}

export interface RelationshipBasicPayorDtoArrayResponse {
    payeeRelationships: RelationshipBasicPayorDTO[];
}

export interface RelationshipBasicPayorDTO {
    address: AddressDto | null;
    availableInvoiceAmount: number;
    availableInvoiceCount: number;
    currentTerm: PaymentTermBasicDTO | null;
    defaultPayoutMethod: string;
    dotNumber: string | null;
    id: string;
    externalPayeeKey: string | null;
    factorCompanyName: string | null;
    isClaimed: boolean;
    isPayeeSelectCarrier: boolean;
    isQuickPayRestrictionEnabled: boolean;
    mcNumber: string | null;
    name: string | null;
    payor: GuidDto | null;
    outstandingCreditNoteAmount: number;
    outstandingCreditNoteCount: number;
    isHeldByPayorSystem: boolean;
    scac: string | null;
    status: TypeDto | null;
}

export interface PaymentTermBasicDTO {
    id: string | null;
    isQuickPay: boolean;
}

export interface RelationshipDtoResponse {
    payeeRelationship: RelationshipDto;
}

export interface RelationshipDto extends BaseModel {
    acknowledgeTermsDate: string | null;
    address: AddressDto | null;
    assignedFactor: FactorDto | null;
    availableAdvanceTerms: AdvanceTermDto[] | null;
    availableInvoiceAmount: number;
    availableInvoiceCount: number;
    availablePaymentTerms: PaymentTermDto[];
    bankAccount: BankAccountDto | null;
    claimWithoutVerificationAttemptsRemaining: number;
    contactName: string;
    currentAdvanceTerm: AdvanceTermDto | null;
    currentAdvanceTermCreditLimit: number | null;
    currentPaymentTerm: PaymentTermDto | null;
    dotNumber: string;
    externalPayeeKey: string;
    highwayDetails: HighwayDetailsDTO | null;
    id: string;
    isClaimed: boolean;
    isSelectCarrierCompliant: boolean;
    isTermEditable: boolean;
    isTermsAcknowledged: boolean;
    isQuickPayAllowed: boolean;
    isQuickPayRestrictionEnabled: boolean;
    isPayeeSelectCarrier: boolean;
    mcNumber: string;
    name: string;
    namedReferenceNumbers: ReferenceNumberModel[];
    outstandingCreditNoteAmount: number;
    outstandingCreditNoteCount: number;
    paidInvoiceAmount: number | null;
    payor: RelationshipPayorDto;
    preVerified: boolean;
    primaryEmail: string;
    primaryPhoneNumber: string;
    relationshipCategory: string | null;
    scac: string;
    status: StatusTypeDto;
    uploadedDateTime: string;
    verificationMethods: VerificationMethodDto[] | null;
    isHeldByPayorSystem: boolean;
    holds: ActiveHoldDto[];
}

export interface FactorDto {
    address: AddressDto;
    id: string;
    name: string;
}

export interface AdvanceTermDto {
    advanceRatePercentage: number;
    advanceType: AdvanceType;
    daysToPay: number;
    flatFee: number;
    id: string;
    name: string;
    percentageFee: number;
}

export interface DataAccessObjectBaseOfTriumphPayConstants {
}

export interface AdvanceType extends DataAccessObjectBaseOfTriumphPayConstants {
    id: AdvanceTypeId;
    name: string;
}

export enum AdvanceTypeId {
    SHIPPER_ADVANCE = 1,
    REFUND_TERM_FEE = 2,
    REFUND_ADVANCE_FEE = 3,
    REFUND_STOP_PAYMENT_FEE = 4,
    TRIUMPH_LOAD_ADVANCE = 5,
    TRIUMPH_LOAD_ADVANCE_REFUND_ADVANCE_FEE = 6,
}

export interface RelationshipPayorDto extends BaseModel {
    address: AddressDto | null;
    apEmail: string | null;
    currencyType: TypeDto | null;
    dotNumber: string | null;
    goLiveDateTime: string | null;
    id: string;
    isInPaymentsNetwork: boolean | null;
    isLoadAdvancesEnabled: boolean | null;
    promoteLoadAdvancesToCarrier: boolean | null;
    isSelectCarrierCompliant: boolean;
    iconData: string | null;
    mcNumber: string | null;
    name: string | null;
    noaEmail: string | null;
    payorTierTypeId: PayorTierTypeId | null;
    payorTypeId: number;
    phoneNumber: string | null;
    primaryContactName: string | null;
    primaryEmail: string;
    quickPayTerm: PaymentTermDto | null;
    qpEmail: string | null;
    spEmail: string | null;
    website: string | null;
}

export enum PayorTierTypeId {
    Tier1 = 1,
    Tier2 = 2,
    Tier3 = 3,
    Tier4 = 4,
}

export interface VerificationMethodDto {
    value: string;
    type: TypeDto;
}

export interface RelationshipNamesResponse {
    payeeRelationships: GuidDto[];
}

export interface StatusResponse {
    statuses: TypeDto[];
}

export interface FactorSearchPayeeRelationshipsResponse {
    payeeRelationships: FactorPayeeRelationshipSearchResult[];
}

export interface FactorPayeeRelationshipSearchResult {
    companyName: string;
    dotNumber: string;
    mcNumber: string;
    payeeRelationshipId: string;
}

export interface CreditNoteDtoArrayResponse {
    creditNotes: CreditNoteDto[];
}

export interface CreditNoteDtoResponse {
    creditNote: CreditNoteDto;
}

export interface InvoiceStatusResponse {
    invoiceStatuses: TypeDto[];
}

export interface DateTypesResponse {
    dateTypes: EnumTypeDtoOfSearchDateTypeId[];
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateCreditNoteRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateCreditNoteRequest extends BaseModelOfUpdateCreditNoteRequestAndTriumphPayEntities {
}

export interface UpdateCreditNoteRequest extends CoreAPIRequestBaseOfUpdateCreditNoteRequest {
    holdCredit: boolean | null;
    holdReason: string | null;
}

export interface SearchFactorNamesResponse {
    factors: GuidDto[] | null;
}

export interface SearchHighwayWatchListResponse {
    highwayCarriers: HighwayWatchListRelationshipDTO[];
}

export interface HighwayWatchListRelationshipDTO {
    alertCount: number;
    alertExpiredDate: string | null;
    availableInvoiceAmount: number;
    isPaymentTermQuickPay: boolean;
    name: string;
    nextPaymentDate: string | null;
    payeeRelationshipId: string;
    status: TypeDto;
}

export interface GetHighwayWatchListStatusesResponse {
    statuses: HighwayWatchListStatusDTO[];
}

export interface HighwayWatchListStatusDTO extends TypeDto {
    count: number;
}

export interface GetHighwaySummaryResponse {
    relationshipCount: number;
    totalInvoiceAmount: number;
}

export interface GetDashboardInsightsResponse {
    bankFees: PayorBankFeesInsightsDto[];
    misdirectedPayments: PayorMisdirectedPaymentsInsightsDto[];
    processingTime: PayorProcessingTimeInsightsDto[];
    quickPay: PayorQuickPayInsightsDto;
}

export interface PayorBankFeesInsightsDto {
    bankAccountType: BankAccountTypeDto;
    payoutCount: number;
    savingsAmount: number;
}

export interface PayorMisdirectedPaymentsInsightsDto {
    misdirectedPaymentType: EnumTypeDtoOfPayorInsightMisdirectedPaymentType;
    amount: number;
    count: number;
}

export interface BaseTypeDtoOfPayorInsightMisdirectedPaymentType {
    id: PayorInsightMisdirectedPaymentType;
    name: string | null;
}

export interface EnumTypeDtoOfPayorInsightMisdirectedPaymentType extends BaseTypeDtoOfPayorInsightMisdirectedPaymentType {
}

/** Insight misdirected payment types for payors. */
export enum PayorInsightMisdirectedPaymentType {
    IncorrectFactor = 1,
    RejectedBankAccounts = 2,
}

export interface PayorProcessingTimeInsightsDto {
    processingTimeType: EnumTypeDtoOfPayorInsightProcessingType;
    timeSavedInMinutes: number;
    count: number;
}

export interface BaseTypeDtoOfPayorInsightProcessingType {
    id: PayorInsightProcessingType;
    name: string | null;
}

export interface EnumTypeDtoOfPayorInsightProcessingType extends BaseTypeDtoOfPayorInsightProcessingType {
}

/** Insight processing types for payors. */
export enum PayorInsightProcessingType {
    NoaLor = 1,
    CarrierBankAccount = 2,
}

export interface PayorQuickPayInsightsDto {
    adoptionPercentageAverage: number;
    adoptionPercentageByAmount: number;
    data: PayorQuickPayInsightsData[];
}

export interface PayorQuickPayInsightsData {
    adoptionPercentage: number;
    adoptionPercentageByAmount: number;
    categoryAverage: number;
    categoryAverageByAmount: number;
    date: string;
    endDate: string;
}

export interface SearchPayorInvoicesResponse {
    invoices: PayorInvoiceDto[];
}

export interface PayorInvoiceDto {
    factorCompanyName: string | null;
    id: string;
    invoiceNo: string;
    isAdvance: boolean;
    isDuplicate: boolean;
    netAmount: number;
    netAmountAfterPayeeTermFee: number;
    payeeRelationship: GuidDto | null;
    paymentDate: string | null;
    paymentTerm: PaymentTermDto | null;
    referenceNo: string;
    namedReferenceNumbers: ReferenceNumberModel[] | null;
    status: StatusTypeDto;
    uploadedDate: string;
    scheduledPaymentDate: string | null;
}

export interface InvoiceTermsResponse {
    availablePaymentTerms: PaymentTermDto[];
    invoiceIds: string[];
    fullCount: number;
    fullAmount: number;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateBulkInvoiceTermsRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateBulkInvoiceTermsRequest extends BaseModelOfUpdateBulkInvoiceTermsRequestAndTriumphPayEntities {
}

export interface UpdateBulkInvoiceTermsRequest extends CoreAPIRequestBaseOfUpdateBulkInvoiceTermsRequest {
    invoiceIds: string[];
    termId: string | null;
}

export interface DraftTotalDto {
    draftTotal: number | null;
}

export interface AutoSelectFinanceSummary {
    totalCount: number;
    totalAmount: number;
    financeDueDate: string;
    financedDueDates: GroupedDraftDateAmountItem[];
    selectedInvoices: string[];
}

export interface GroupedDraftDateAmountItem {
    draftDate: string;
    amount: number;
}

export interface FinanceableInvoiceSummaryResponse {
    count: number;
    amount: number;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfPayorFinanceInvoiceRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfPayorFinanceInvoiceRequest extends BaseModelOfPayorFinanceInvoiceRequestAndTriumphPayEntities {
}

export interface PayorFinanceInvoiceRequest extends CoreAPIRequestBaseOfPayorFinanceInvoiceRequest {
    invoiceIds: string[];
    payoutTermCode: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateReleaseRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateReleaseRequest extends BaseModelOfUpdateReleaseRequestAndTriumphPayEntities {
}

export interface UpdateReleaseRequest extends CoreAPIRequestBaseOfUpdateReleaseRequest {
    paymentTermId: string | null;
    holdReason: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateRemoveRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateRemoveRequest extends BaseModelOfUpdateRemoveRequestAndTriumphPayEntities {
}

export interface UpdateRemoveRequest extends CoreAPIRequestBaseOfUpdateRemoveRequest {
    removeReason: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateInvoiceRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateInvoiceRequest extends BaseModelOfUpdateInvoiceRequestAndTriumphPayEntities {
}

export interface UpdateInvoiceRequest extends CoreAPIRequestBaseOfUpdateInvoiceRequest {
    paymentTermId: string | null;
    holdInvoice: boolean | null;
    holdReason: string | null;
}

export interface InvoiceStatusWithCountResponse {
    invoiceStatuses: TypeCountDto[];
}

export interface TypeCountDto extends TypeDto {
    count: number;
    amount: number;
}

export interface HeldInvoicesResponse {
    /** Total number of records before pagination */
    fullCount: number;
    maxScheduledPaymentDate: string | null;
    heldInvoices: HeldInvoiceDto[];
}

export interface HeldInvoiceDto {
    invoiceGuid: string;
    invoiceNumber: string;
    isOverdue: boolean;
    isQuickPay: boolean;
    netAmountDue: number;
    scheduledPayDate: string | null;
    payeeRelationship: GuidDto;
    earliestHoldDate: string;
    holds: HeldInvoiceHoldSummaryDto[];
}

export interface HeldInvoiceHoldSummaryDto {
    holdPlacedDate: string;
    holdLevel: string;
    holdReason: string | null;
    heldByType: string | null;
}

/** Enum equivalent of the calculated "Held By" values created in GetHoldPlacedByForReasonId */
export enum PayorInvoiceHoldReportHeldByType {
    Broker = 1,
    Shipper = 2,
    TriumphPay = 3,
}

export interface InvoiceHoldsResponse {
    activeHolds: ActiveHoldDto[];
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfFileUploadRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfFileUploadRequest extends BaseModelOfFileUploadRequestAndTriumphPayEntities {
}

export interface FileUploadRequest extends CoreAPIRequestBaseOfFileUploadRequest {
    fileData: string;
    fileName: string;
}

export interface SearchPayeeNamesResponse {
    names: GuidDto[];
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfSearchPayeeNamesRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfSearchPayeeNamesRequest extends BaseModelOfSearchPayeeNamesRequestAndTriumphPayEntities {
}

export interface SearchPayeeNamesRequest extends CoreAPIRequestBaseOfSearchPayeeNamesRequest {
    ids: string[];
}

export interface TopRelationshipsResponse {
    payeeRelationships: TopRelationshipsResponseItem[];
}

export interface TopRelationshipsResponseItem {
    payeeRelationship: GuidDto;
    activityInvoiceAmount: number;
    activityInvoiceCount: number;
}

export interface RelationshipCategoriesResponse {
    categories: TypeStringDto[];
}

export interface TypeStringDto extends BaseModel {
    id: string;
    name: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateRelationshipRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateRelationshipRequest extends BaseModelOfUpdateRelationshipRequestAndTriumphPayEntities {
}

export interface UpdateRelationshipRequest extends CoreAPIRequestBaseOfUpdateRelationshipRequest {
    paymentTermId: string | null;
    relationshipCategory: string | null;
    isQuickpayAllowed: boolean | null;
    holdRelationship: boolean | null;
    disableRelationship: boolean | null;
    alertMessage: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateRelationshipAdvanceRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateRelationshipAdvanceRequest extends BaseModelOfUpdateRelationshipAdvanceRequestAndTriumphPayEntities {
}

export interface UpdateRelationshipAdvanceRequest extends CoreAPIRequestBaseOfUpdateRelationshipAdvanceRequest {
    advanceTermId: string | null;
    advanceTermCreditLimit: number | null;
}

export interface GetHighwayProfileUrlResponse {
    highwayProfileUrl: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdatePayeeRelationshipHighwayRelationshipStatusRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdatePayeeRelationshipHighwayRelationshipStatusRequest extends BaseModelOfUpdatePayeeRelationshipHighwayRelationshipStatusRequestAndTriumphPayEntities {
}

export interface UpdatePayeeRelationshipHighwayRelationshipStatusRequest extends CoreAPIRequestBaseOfUpdatePayeeRelationshipHighwayRelationshipStatusRequest {
    isIgnored: boolean;
}

export interface BillingReportResponse {
    billingActivity: BillingReportActivityItem[];
    totals: BillingReportActivityItem;
    omitFundingColumns: boolean;
}

export interface BillingReportActivityItem {
    amountDue: number | null;
    amountReceived: number | null;
    dueDate: string | null;
    invoiceDraftGuid: string | null;
    invoiceDraftExternalId: number | null;
    batchId: string | null;
    lateFees: number | null;
    quickPayCount: number | null;
    quickPayRebate: number | null;
    standardPayCount: number | null;
    standardPayFees: number | null;
    isReconciled: boolean;
    amountOutstanding: number | null;
    isOverdue: boolean;
}

export interface CreditUsageResponse {
    creditLimit: number | null;
    currentBalance: number;
    percentage: number;
}

export interface SettlementStatementResponse {
    settlementStatments: SettlementStatementDto[];
    hasMonthlyInvoiceFees: boolean;
}

export interface SettlementStatementDto {
    amountPaid: number;
    id: string;
    paidBy: string;
    statementDue: string | null;
    totalAmountDue: number;
    type: TypeDto;
}

export interface FinancialAccountActivityResponse {
    transactionLineItems: FinancialAccountActivityItem[];
}

export interface FinancialAccountActivityItem {
    balance: number;
    creditAmount: number | null;
    creditPercentage: number | null;
    debitAmount: number | null;
    invoice: InvoiceBasicDto | null;
    id: number;
    note: string | null;
    payeeRelationship: RelationshipBasicDto | null;
    payment: PaymentBasicDto | null;
    transactionDate: string;
    transactionId: number;
    transactionLineItemType: string | null;
    transactionType: string | null;
    defaultPaymentTerm: string | null;
}

export interface InvoiceBasicDto {
    id: string;
    externalKey: string | null;
    referenceNo: string | null;
    invoiceNo: string | null;
}

export interface RelationshipBasicDto extends GuidDto {
    externalKey: string | null;
    dotNumber: string | null;
    mcNumber: string | null;
}

export interface PaymentBasicDto {
    confirmationCode: string;
    id: string;
    transactionCode: string;
}

export interface ListTermsResponse {
    terms: PaymentTermDto[];
}

export interface ProfileSettingsResponse {
    profileSettings: ProfileSettingValueDTO[];
}

export interface ProfileSettingValueDTO extends TypeDto {
    value: string;
}

export interface IntsRequest {
    ids: number[] | null;
}

export interface ProfileSettingTypesResponse {
    profileSettingTypes: TypeDto[];
}

export interface UpdateQuickpaySettingsResult {
    payeeQuickpaySetting: ProfileSettingItem;
    standardPayInvoiceCountSetting: ProfileSettingItem;
}

export interface ProfileSettingItem {
    id: number;
    name: string;
    value: string;
}

export interface UpdateQuickpaySettingsRequest {
    isQuickPayEnabled: boolean;
    standardPayInvoiceThresholdCount: number;
}

export interface Relationship1099Response {
    results: Relationship1099Dto[];
}

export interface Relationship1099Dto {
    payeeName: string | null;
    remitAddr1: string | null;
    remitAddr2: string | null;
    remitCity: string | null;
    remitState: string | null;
    remitPostalCode: string | null;
    taxIdType: string | null;
    taxId: string | null;
    externalPayeeKey: string | null;
    factorName: string | null;
    factorAddr1: string | null;
    factorAddr2: string | null;
    factorCity: string | null;
    factorState: string | null;
    factorPostalCode: string | null;
    invoiceNetAmount: number;
    payeeTermFeesToTriumph: number;
    payeeTermFeesToPayor: number;
    paymentFees: number;
}

export interface PayorInvoiceBatchReviewResponse {
    payorInvoiceBatchReviews: PayorInvoiceBatchReviewDto[];
}

export interface PayorInvoiceBatchReviewDto {
    amountDue: number;
    amountReceived: number;
    approvedCount: number;
    batchId: string;
    duplicatesCount: number;
    heldCount: number;
    id: string;
    reviewByDate: string | null;
    status: TypeDto | null;
}

export interface GotpFeeMonthsResponse {
    fees: GotpInvoiceFeesByMonthDto[];
}

export interface GotpInvoiceFeesByMonthDto {
    payorCompanyId: number;
    totalFees: number;
    monthEndId: number | null;
    monthEndDate: string | null;
}

export interface PayorTasksResponse {
    dueSoonDaysThreshold: number;
    heldInvoiceDueSoonCount: number;
    heldInvoicePastDueCount: number;
    heldQuickPayInvoicesCount: number;
}

export interface GetPayorUnreconciledFundsTransactionsResponse {
    fullCount: number;
    transactions: PayorUnreconciledFundsTransactionDto[];
}

export interface PayorUnreconciledFundsTransactionDto {
    batchIds: string[];
    creditAmount: number;
    date: string;
    id: string;
    note: string;
    transactionId: number;
}

export interface SearchFactorPaymentsResponse {
    payments: FactorPaymentDto[];
}

export interface FactorPaymentDto {
    id: string;
    paidDate: string | null;
    status: TypeDto;
    payor: PayorBasicDto;
    payeeRelationship: GuidDto | null;
    bankAccount: FactorPaymentBankDto;
    totalPaymentAmount: number;
}

export interface FactorPaymentBankDto {
    name: string;
}

export interface GetPaymentResponse {
    payment: PaymentDto;
}

export interface GetPaymentImagesResponse {
    images: string[];
}

export interface GetStatusesResponse {
    paymentStatuses: TypeDto[];
}

export interface GetPayorCompanyResponse {
    payor: RelationshipPayorDto;
}

export interface LookupPayorNamesResponse {
    names: GuidDto[];
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfLookupPayorNamesRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfLookupPayorNamesRequest extends BaseModelOfLookupPayorNamesRequestAndTriumphPayEntities {
}

export interface LookupPayorNamesRequest extends CoreAPIRequestBaseOfLookupPayorNamesRequest {
    ids: string[];
}

export interface SearchPayorsResponse {
    payors: RelationshipPayorDto[];
}

export interface SearchPayorNamesResponse {
    payors: PayorBasic2Dto[];
}

export interface PayorBasic2Dto extends PayorBasicDto {
    dotNumber: string | null;
    hasApEmail: boolean;
    isPaperworkEnabled: boolean;
    mcNumber: string | null;
    relationshipId: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUploadNoaRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUploadNoaRequest extends BaseModelOfUploadNoaRequestAndTriumphPayEntities {
}

export interface UploadNoaRequest extends CoreAPIRequestBaseOfUploadNoaRequest {
    isRelease: boolean;
    file: FileDto;
    mcNumber: string;
}

export interface UpdateBankAccountResponse {
    bankAccount: BankAccountDto;
}

export interface UpdateBankAccountRequest {
    address: AddressDto | null;
    bankAccountTypeId: number;
    bankAccountNumber: string | null;
    beneficiaryName: string | null;
    confirmBankAccountNumber: string | null;
    intermediaryRoutingNumber: string | null;
    routingNumber: string | null;
    loadPayCompanyId: string | null;
}

export interface BankAccountStatusResponse {
    id: string;
    destinationDescription: string;
    isValidationRequired: boolean;
    status: TypeDto;
}

export interface ListBankTypeRequirementsResponse {
    bankAccountTypes: BankTypeRequirementsDTO[];
}

export interface BankTypeRequirementsDTO {
    address: BankFieldRequrementDTO | null;
    bankAccountNumber: BankFieldRequrementDTO | null;
    bankAccountNumberComponents: BankAccountNumberComponentsDTO | null;
    confirmBankAccountNumberLabel: string | null;
    bankAccountType: TypeDto;
    beneficiaryName: BankFieldRequrementDTO | null;
    country: BankFieldRequrementDTO | null;
    currencyType: TypeDto;
    intermediaryRoutingNumber: BankFieldRequrementDTO | null;
    paymentFee: number;
    routingNumber: BankFieldRequrementDTO | null;
    postalCode: PostalCodeRequirementDTO | null;
    bankStateRequirement: BankStateRequirementDTO | null;
    countryRequirements: { [key in keyof typeof Alpha2Code]?: BankTypeRequirementsDTO; } | null;
    defaultCountryRequirements: BankTypeRequirementsDTO | null;
    additionalAccountField: BankFieldRequrementDTO | null;
}

export interface BankFieldRequrementDTO {
    digitCount: number | null;
    isRequired: boolean;
    isABA: boolean | null;
    label: string | null;
    defaultValue: string | null;
    isSwift: boolean | null;
}

export interface BankAccountNumberComponentsDTO {
    field1: BankFieldRequrementDTO;
    field2: BankFieldRequrementDTO | null;
}

export interface PostalCodeRequirementDTO extends BankFieldRequrementDTO {
    isUsOrCaPostalCode: boolean;
}

export interface BankStateRequirementDTO extends BankFieldRequrementDTO {
    isStateIsoCodeRequired: boolean;
    isStateRequired: boolean;
}

export interface BankAccountRequest {
    address: AddressDto | null;
    bankAccountTypeId: number;
    bankAccountNumber: string | null;
    beneficiaryName: string | null;
    confirmBankAccountNumber: string | null;
    intermediaryRoutingNumber: string | null;
    routingNumber: string | null;
    loadPayCompanyId: string | null;
}

export interface LookupAbaResponse {
    bankAba: TypeStringDto;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfCreateCompanyRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfCreateCompanyRequest extends BaseModelOfCreateCompanyRequestAndTriumphPayEntities {
}

export interface CreateCompanyRequest extends CoreAPIRequestBaseOfCreateCompanyRequest {
    apiKey: string;
    apiSecret: string;
    user: CreateCompanyUserRequest;
    signatureInCookie: boolean;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfCreateCompanyUserRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfCreateCompanyUserRequest extends BaseModelOfCreateCompanyUserRequestAndTriumphPayEntities {
}

export interface CreateCompanyUserRequest extends CoreAPIRequestBaseOfCreateCompanyUserRequest {
    email: string;
    name: string;
    notifications: NotificationRequest[] | null;
    phoneNumber: string;
    company: CreateUserCompanyRequest;
    confirmPassword: string;
    password: string;
    verificationCode: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfCreateUserCompanyRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfCreateUserCompanyRequest extends BaseModelOfCreateUserCompanyRequestAndTriumphPayEntities {
}

export interface CreateUserCompanyRequest extends CoreAPIRequestBaseOfCreateUserCompanyRequest {
    dotNumber: string | null;
    mcNumber: string | null;
    scac: string | null;
    hasNoMcOrDot: boolean;
    name: string;
    code: string | null;
    payeeRelationshipId: string | null;
}

export interface CompanyResponse {
    company: CompanyDto;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateCompanyRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateCompanyRequest extends BaseModelOfUpdateCompanyRequestAndTriumphPayEntities {
}

export interface UpdateCompanyRequest extends CoreAPIRequestBaseOfUpdateCompanyRequest {
    company: UpdateCompanyDetails;
}

export interface UpdateCompanyDetails {
    name: string;
    mcNumber: string | null;
    dotNumber: string | null;
    scac: string | null;
}

export interface SearchInvoicesAndCreditNotesResponse {
    invoices: InvoiceOrCreditDto[];
}

export interface InvoiceOrCreditDto extends BaseModel {
    grossAmount: number;
    id: string;
    invoiceNo: string | null;
    isPaymentTermEditable: boolean;
    isMissingEft: boolean;
    referenceNo: string | null;
    netAmount: number;
    netAmountAfterPayeeTermFee: number;
    payeeRelationship: GuidDto | null;
    paymentDate: string | null;
    paymentTerm: PaymentTermDto | null;
    payor: PayorBasicDto | null;
    status: StatusTypeDto | null;
    type: TypeDto | null;
    hasPromotionalInvoice: boolean;
    willPayToLoadPayBankAccount: boolean;
}

export interface QpAvailableResponse extends BaseModel {
    netAmountAfterDefaultFees: number;
    quickPayableRelationships: { [key: string]: QpAvailableResponseItem; };
}

export interface QpAvailableResponseItem {
    netInvoiceTotal: number;
    payor: PayorBasicDto;
    quickPayTerms: PaymentTermDto[];
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateInvoiceRequestAndTriumphPayEntities2 extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateInvoiceRequest2 extends BaseModelOfUpdateInvoiceRequestAndTriumphPayEntities2 {
}

export interface UpdateInvoiceRequest2 extends CoreAPIRequestBaseOfUpdateInvoiceRequest2 {
    paymentTermId: string;
}

export interface LoadPayPromotionDto {
    promotionId: LoadPayPromotionId;
    marketingUrl: string;
}

export enum LoadPayPromotionId {
    CHR = 1,
}

export interface LinkToLoadPayApplicationRequest {
    companyApplicationId: string;
}

export interface SearchPaymentsResponse {
    payments: PaymentDto[];
}

export enum PayoutFilterTypeId {
    Invoices = 1,
    Advances = 2,
}

export interface ListPayeePromotionalCampaignsResponse {
    promotionalCampaigns: PayeePromotionalCampaignResponseDto[];
}

export interface PayeePromotionalCampaignResponseDto {
    endDate: string;
    firstQuickpayInvoicePaidDate: string | null;
    id: string;
    invoiceAmount: number;
    invoiceCount: number;
    payor: GuidDto;
    quickpayElectedDate: string | null;
    relationshipClaimedDate: string | null;
    startDate: string;
    status: TypeDto;
}

export interface ListPayeePromotionalInvoicesByCampaignResponse {
    promotionalInvoicesByCampaign: PayeePromotionalInvoicesByCampaignResponseDto[];
}

export interface PayeePromotionalInvoicesByCampaignResponseDto {
    campaign: PayeePromotionalCampaignResponseDto;
    promotionalInvoicesRemaining: number;
    invoiceStartDate: string | null;
    invoiceEndDate: string | null;
}

export interface CurrentRelationshipsResponse {
    availableForQuickpayInvoiceAmount: number;
    availableForQuickpayInvoiceCount: number;
    payeeRelationships: RelationshipDto[];
}

export interface CurrentRelationshipResponse {
    payeeRelationship: RelationshipDto;
}

export interface UnclaimedRelationshipsResponse {
    payeeRelationships: RelationshipDto[];
}

export interface RelationshipIdsByContactInfoDto {
    id: string;
    verificationMethodValue: string;
    verificationMethodTypeId: number;
    payeeRelationshipIds: string[];
    isPreVerified: boolean;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfSendVerificationByContactMethodTokenRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfSendVerificationByContactMethodTokenRequest extends BaseModelOfSendVerificationByContactMethodTokenRequestAndTriumphPayEntities {
}

export interface SendVerificationByContactMethodTokenRequest extends CoreAPIRequestBaseOfSendVerificationByContactMethodTokenRequest {
    payeeContactMethodId: string;
    verificationMethodTypeId: number;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfSendVerificationTokenRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfSendVerificationTokenRequest extends BaseModelOfSendVerificationTokenRequestAndTriumphPayEntities {
}

export interface SendVerificationTokenRequest extends CoreAPIRequestBaseOfSendVerificationTokenRequest {
    verificationMethodIndex: number;
    verificationMethodTypeId: number;
}

export interface TermsOfServiceResponse {
    terms: string;
}

export interface ActivePromotionalCampaignResponse {
    promotionalCampaign: PayeePromotionalCampaignResponseDto | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfClaimRelationshipsRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfClaimRelationshipsRequest extends BaseModelOfClaimRelationshipsRequestAndTriumphPayEntities {
}

export interface ClaimRelationshipsRequest extends CoreAPIRequestBaseOfClaimRelationshipsRequest {
    payeeRelationshipGuids: string[];
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfClaimRelationshipsForContactMethodRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfClaimRelationshipsForContactMethodRequest extends BaseModelOfClaimRelationshipsForContactMethodRequestAndTriumphPayEntities {
}

export interface ClaimRelationshipsForContactMethodRequest extends CoreAPIRequestBaseOfClaimRelationshipsForContactMethodRequest {
    verificationCode: string | null;
    payeeContactMethodId: string | null;
    isTermsAcknowledged: boolean;
    payeeRelationshipIds: string[] | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfClaimRelationshipWithoutVerificationRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfClaimRelationshipWithoutVerificationRequest extends BaseModelOfClaimRelationshipWithoutVerificationRequestAndTriumphPayEntities {
}

export interface ClaimRelationshipWithoutVerificationRequest extends CoreAPIRequestBaseOfClaimRelationshipWithoutVerificationRequest {
    isTermsAcknowledged: boolean;
    invoiceOrLoadNumber: string;
    invoiceOrLoadAmount: number;
}

export interface ClaimRelationshipResponse {
    payeeRelationship: RelationshipDto;
    preAuthenticatedGuids: string[];
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfClaimRelationshipRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfClaimRelationshipRequest extends BaseModelOfClaimRelationshipRequestAndTriumphPayEntities {
}

export interface ClaimRelationshipRequest extends CoreAPIRequestBaseOfClaimRelationshipRequest {
    verificationCode: string | null;
    verificationMethodIndex: number;
    verificationMethodTypeId: number;
    isTermsAcknowledged: boolean;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateRelationshipRequestAndTriumphPayEntities2 extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateRelationshipRequest2 extends BaseModelOfUpdateRelationshipRequestAndTriumphPayEntities2 {
}

export interface UpdateRelationshipRequest2 extends CoreAPIRequestBaseOfUpdateRelationshipRequest2 {
    paymentTermId: string;
    sendFreshdesk: boolean;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateRelationshipUnauthenticatedRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateRelationshipUnauthenticatedRequest extends BaseModelOfUpdateRelationshipUnauthenticatedRequestAndTriumphPayEntities {
}

export interface UpdateRelationshipUnauthenticatedRequest extends CoreAPIRequestBaseOfUpdateRelationshipUnauthenticatedRequest {
    paymentTermId: string;
    isTermsAcknowledged: boolean;
    email: string;
    token: string;
    skipFreshdesk: boolean;
}

export interface FactorMarketingPageResponse extends BaseModel {
    factorApEmail: string | null;
    factorName: string | null;
    invoices: MarketingInvoiceDTO[] | null;
    payeeEmail: string | null;
    payeeName: string | null;
    payorApEmail: string | null;
    payorNoaEmail: string | null;
    payorIconData: string | null;
    payorName: string | null;
    paymentTerm: PaymentTermDto | null;
    payorWebsite: string | null;
    relationshipId: string;
}

export interface MarketingInvoiceDTO {
    amount: number;
    invoiceNo: string | null;
    payDate: string | null;
    referenceNo: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfCreateClaimIntentRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfCreateClaimIntentRequest extends BaseModelOfCreateClaimIntentRequestAndTriumphPayEntities {
}

export interface CreateClaimIntentRequest extends CoreAPIRequestBaseOfCreateClaimIntentRequest {
    code: string;
}

export interface SelectCarrierActiveOpportunityResponse {
    id: string;
    status: TypeDTO | null;
    rate: number;
}

export interface TypeDTO {
    id: number;
    name: string | null;
}

export interface AcceptSelectCarrierRateRequest {
    offerId: string | null;
    selectedViaMobile: boolean | null;
}

export interface SearchPayorPaymentsResponse {
    payments: PayorPaymentDto[];
}

export interface PayorPaymentDto {
    id: string;
    paidDate: string | null;
    payoutTypeId: EnumTypeDtoOfPayoutTypeId;
    status: TypeDto;
    payeeRelationship: GuidDto | null;
    bankAccount: PayorPaymentBankDto;
    totalPaymentAmount: number;
}

export interface PayorPaymentBankDto {
    name: string;
}

export interface PayorEmailPaymentsRequest {
    payeeRelationshipId: string | null;
    emailAddresses: string[];
}

export interface GetAdvancePayorsResponse {
    fullCount: number;
    payors: AdminAdvancePayorListDto[];
}

export interface AdminAdvancePayorListDto {
    payor: GuidDto;
    relationshipsPendingCreditExposure: number;
    relationshipsCurrentCreditExposure: number;
    relationshipsTotalCreditExposure: number;
    relationshipTotalCreditLimit: number;
    creditExposurePercentage: number;
    sevenDayExposureFallOff: number;
    fundedNotClosedAmount: number;
}

export interface GetAdvancePayorResponse {
    fullCount: number;
    payor: GuidDto;
    relationships: AdminAdvancePayorRelationshipDto[];
}

export interface AdminAdvancePayorRelationshipDto {
    amountExceedingCreditLimit: number;
    creditLimit: number;
    creditUtilizationPercentage: number;
    currentCreditExposure: number;
    id: string;
    name: string;
    pendingCreditExposure: number;
    totalCreditExposure: number;
    sevenDayExposureFallOff: number;
    fundedNotClosedAmount: number;
}

export interface GetAdvanceRelationshipResponse {
    advances: AdminRelationshipAdvanceDto[];
    payor: GuidDto;
    relationship: GuidDto;
}

export interface AdminRelationshipAdvanceDto {
    advanceScheduledPaymentDate: string;
    dueDateTime: string | null;
    grossAmount: number;
    hasPendingRecourseRequests: boolean;
    id: string;
    netAmount: number;
    openBalance: number;
    referenceNumber: string;
    shortPaidAmount: number;
    termCode: string;
}

export interface OutstandingAdvanceDTO {
    payors: IdAndNameDTOOfGuid[];
    relationships: AdvanceRelationshipDTO[];
    scacs: IdAndNameDTOOfString[];
    advances: AdvanceDTO[];
}

export interface IdAndNameDTOOfGuid {
    id: string;
    name: string;
}

export interface AdvanceRelationshipDTO extends IdAndNameDTOOfGuid {
    advanceCreditLimit: number | null;
}

export interface IdAndNameDTOOfString {
    id: string | null;
    name: string;
}

export interface AdvanceDTO {
    advanceId: string;
    ageDays: number;
    advancesWithoutRecourseGrossAmount: number;
    grossAmount: number;
    netAmount: number;
    openBalance: number;
    advanceTermCode: string | null;
    dueDateTime: string | null;
    hasPendingRecourseRequest: boolean;
    invoiceNumber: string | null;
    payorId: string;
    relationshipId: string;
    referenceNumber: string | null;
    shortPaidAmount: number;
    scac: string | null;
}

export interface UpdateAdvanceRequest {
    advanceIds: string[];
}

export interface GetDateTypesResponse {
    dateTypes: EnumTypeDtoOfSearchDateTypeId[];
}

export interface PendingBankListItemDto {
    carrier: CarrierDto | null;
    bankRequest: BankRequestDto;
    id: string;
    highRiskReasons: RiskFactorDto[];
    isHighRisk: boolean;
    isRiskManuallyEscalated: boolean;
    isFromCarrierPacket: boolean;
    importSource: string;
    paidInvoiceAmount: number;
    immediatePendingInvoiceAmount: number;
    immediatePendingQuickPayAmount: number;
    pendingInvoiceAmount: number;
    existingBankId: string | null;
    assignedTo: UserContactInfoDto | null;
    status: number;
    rejectionStatus: TypeDto | null;
}

export interface CarrierDto {
    id: string | null;
    name: string | null;
    mcNumber: string | null;
    dotNumber: string | null;
    scac: string | null;
    createdDateTime: string;
    registrationUser: CarrierUserDto | null;
}

export interface CarrierUserDto {
    name: string | null;
    email: string | null;
    phone: string | null;
    changes: CarrierUserChangeDto[];
}

export interface CarrierUserChangeDto {
    changedOn: string;
    field: string;
}

export interface BankRequestDto extends GuidDto {
    type: TypeDto;
    createdDateTime: string;
    createdByUserId: string | null;
    createdByUserRoles: string | null;
    reviewedDateTime: string | null;
    reviewedUserId: string | null;
    reviewResult: TypeDto | null;
    reviewNote: string | null;
    address: AddressDto | null;
    beneficaiaryName: string | null;
    inactivatedDateTime: string | null;
}

export interface RiskFactorDto {
    reason: string;
    isManuallyAssigned: boolean;
}

export interface UserContactInfoDto {
    id: string;
    name: string;
    phoneNumber: string;
    emailAddress: string;
}

export enum BankReviewQueue {
    LowRisk = 0,
    HighRisk = 1,
    FinalReview = 2,
}

export interface BankChangeSummaryResponse {
    count: number;
    finalReviewCount: number;
    highRiskCount: number;
    lowRiskCount: number;
    invoiceAmount: number;
    reviewerCounts: ReviewerSummary[];
    typeCounts: TypeSummary[];
    carrierPacketCount: number;
}

export interface ReviewerSummary {
    id: string;
    name: string;
    count: number;
}

export interface TypeSummary extends TypeDto {
    count: number;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfBankChangeReviewRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfBankChangeReviewRequest extends BaseModelOfBankChangeReviewRequestAndTriumphPayEntities {
}

export interface BankChangeReviewRequest extends CoreAPIRequestBaseOfBankChangeReviewRequest {
    note: string;
    name: string | null;
    title: string | null;
    phoneNumber: string | null;
    bankAccountRejectionTypeId: number | null;
}

export interface ListBankRejectionTypesResponse {
    bankRejectionTypes: TypeDTO[];
}

export interface BrokerAccountSearchResponse {
    brokerAccounts: BrokerAccountSearchResult[];
}

export interface BrokerAccountSearchResult {
    id: string;
    name: string;
    dotNumbers: string[];
    mcNumbers: string[];
    scacs: string[];
    createdAt: string;
}

export interface RandomUnmatchedBrokerAccountResponse {
    ids: string[];
}

export interface BrokerAccountTotalResponse {
    total: number;
}

export interface BrokerAccountResponse {
    brokerAccount: BrokerAccountField;
    globalBrokers: GlobalBroker[];
    importedBrokers: ImportedBroker[];
}

export interface BrokerAccountField {
    id: string;
    name: string;
    dotNumbers: string[];
    mcNumbers: string[];
    scacs: string[];
    ignoredPayorGuids: string[];
    submissionsEnabled: boolean;
    acceptsSubmissionDelivery: boolean;
    disableCashApplication: boolean;
    disallowLoadQueries: boolean;
    isAuditOnly: boolean;
    isAuditOnlyChangedAt: string | null;
    isCoreOnly: boolean;
    isCoreOnlyChangedAt: string | null;
    globalBrokerId: string | null;
    matchedByEmail: string | null;
    matchedAt: string | null;
    markedConflictedByEmail: string | null;
    markedConflictedAt: string | null;
    active: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface GlobalBroker {
    id: string;
    mcNumbers: string[];
    dotNumbers: string[];
}

export interface ImportedBroker {
    id: string;
    source: string;
    mcNumbers: string[];
    dotNumbers: string[];
    dbaName: string | null;
    companyName: string | null;
    createdAt: string;
    updatedAt: string;
    globalBrokerId: string | null;
    fmcsaStatus: string;
    sourceData: SourceData;
    ein: string | null;
    censusTypeDesc: string | null;
    allowedToOperate: boolean | null;
}

export interface SourceData {
    censusType: string;
    statusCode: string;
    totalDrivers: number;
    mcs150Outdated: string;
    totalPowerUnits: number;
}

export interface MatchBrokerAccountRequest {
    brokerAccountId: string;
    globalBrokerId: string;
    userEmail: string;
}

export interface UnmatchBrokerAccountRequest {
    brokerAccountId: string;
    userEmail: string;
}

export interface MarkConflictedBrokerAccountRequest {
    brokerAccountId: string;
    userEmail: string;
}

export interface BrokerCarrierSearchResponse {
    brokerCarriers: BrokerCarrierSearchResult[];
}

export interface BrokerCarrierSearchResult {
    id: string;
    companyName: string;
    dbaName: string;
    dotNumber: string;
    mcNumber: string;
    scac: string;
    createdAt: string;
}

export interface RandomUnmatchedBrokerCarrierResponse {
    ids: string[];
}

export interface BrokerCarrierTotalsResponse {
    audit: number;
    core: number;
    greenscreens: number;
    loadPay: number;
    unifiedApi: number;
    total: number;
}

export interface BrokerCarrierResponse {
    brokerAccount: BrokerAccountField2;
    brokerCarrier: BrokerCarrierField;
    brokerDataSource: BrokerDataSourceField;
    factors: Factor[];
    globalCarriers: GlobalCarrier[];
    importedCarriers: ImportedCarrier[];
}

export interface BrokerAccountField2 {
    id: string;
    name: string;
}

export interface BrokerCarrierField {
    id: string;
    payeeExternalTmsId: string;
    brokerDataSourceId: string;
    dotNumber: string | null;
    mcNumber: string | null;
    scac: string | null;
    address: Address | null;
    createdAt: string;
    updatedAt: string;
    companyName: string;
    isOnHold: boolean;
    globalCarrierId: string | null;
    matchedByEmail: string | null;
    matchedAt: string | null;
    mcNumbers: string[];
    dotNumbers: string[];
    flapping: boolean;
    markedConflictedByEmail: string | null;
    markedConflictedAt: string | null;
    source: string;
    auditCarrierId: string | null;
    deletedAt: string | null;
    coreHubtranIdDataItem: string | null;
    brokerAssignedCoreFactorGuid: string | null;
    taxIds: string[];
    dunsNumbers: string[];
    contacts: Contact[];
    active: boolean;
    dbaName: string | null;
    hasRecentLoadOrInvoice: boolean;
}

export interface Address {
    line1: string;
    line2: string | null;
    city: string;
    state: string;
    postalCode: string;
    countryCode: string;
}

export interface Contact {
    name: string;
    type: string;
    emails: string[];
    phoneNumbers: string[];
    faxNumbers: string[];
}

export interface BrokerDataSourceField {
    id: string;
    brokerAccountId: string;
    name: string;
    hubtranAccountId: number | null;
    tms: string | null;
    corePayorGuids: string[];
    lastUpdateEventAt: string;
    lastReplayedAt: string | null;
    factoringCompanyUpdatesAddedAt: string | null;
    corePayorCurrencies: { [key: string]: string; };
    invoiceMatchingStrategy: string;
    initialAssignmentsCompleted: string[];
    createdAt: string;
    updatedAt: string;
    lastReplayedAuditDmsCarriersAt: string | null;
    lastReplayedAuditDmsLoadsAt: string | null;
    lastReplayedCoreDmsAt: string | null;
    inCarrierConnectorQueue: boolean;
    inCarrierConnectorQueueChangedAt: string | null;
}

export interface Factor {
    id: string;
    name: string;
    remitTo: Address;
}

export interface GlobalCarrier {
    id: string;
    mcNumbers: string[];
    dotNumbers: string[];
    factoringCompanyId: string;
}

export interface ImportedCarrier {
    id: string;
    source: string;
    mcNumbers: string[];
    dotNumbers: string[];
    dbaName: string | null;
    companyName: string | null;
    address: Address;
    createdAt: string;
    updatedAt: string;
    globalCarrierId: string | null;
    fmcsaStatus: string;
    sourceData: SourceData2;
    ein: string | null;
    censusTypeDesc: string | null;
    allowedToOperate: boolean | null;
}

export interface SourceData2 {
    censusType: string;
    statusCode: string;
    totalDrivers: number;
    mcs150Outdated: string;
    totalPowerUnits: number;
}

export interface MatchBrokerCarrierRequest {
    brokerCarrierId: string;
    globalCarrierId: string;
    userEmail: string;
}

export interface UnmatchBrokerCarrierRequest {
    brokerCarrierId: string;
    userEmail: string;
}

export interface MarkConflictedBrokerCarrierRequest {
    brokerCarrierId: string;
    userEmail: string;
}

export interface CompanyDetailsResponse {
    companyId: number;
    companyName: string | null;
    companyType: CompanyTypeDTO;
    mcNumber: string | null;
    dotNumber: string | null;
    isCompanyActive: boolean;
    companyGuid: string;
}

export interface CompanyTypeDTO {
    id: number;
    name: string;
}

export interface DocumentDto {
    createdAt: string;
    createdBy: string | null;
    documentLabel: TypeDto | null;
    documentType: TypeDto | null;
    fileName: string | null;
    id: string;
    fileData: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfDocumentAddRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfDocumentAddRequest extends BaseModelOfDocumentAddRequestAndTriumphPayEntities {
}

export interface DocumentAddRequest extends CoreAPIRequestBaseOfDocumentAddRequest {
    companyId: string;
    documents: DocumentAddRequestItem[];
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfDocumentAddRequestItemAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfDocumentAddRequestItem extends BaseModelOfDocumentAddRequestItemAndTriumphPayEntities {
}

export interface DocumentAddRequestItem extends CoreAPIRequestBaseOfDocumentAddRequestItem {
    documentTypeId: number;
    documentLabelId: number | null;
    fileData: string;
    fileName: string;
}

export interface DocumentPreSignedUrlResponse {
    documentData: DocumentPreSignedUrlResponseItem[];
}

export interface DocumentPreSignedUrlResponseItem {
    fileName: string;
    id: string;
    preSignedUrl: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfDocumentPreSignedUrlsRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfDocumentPreSignedUrlsRequest extends BaseModelOfDocumentPreSignedUrlsRequestAndTriumphPayEntities {
}

export interface DocumentPreSignedUrlsRequest extends CoreAPIRequestBaseOfDocumentPreSignedUrlsRequest {
    companyId: string;
    documents: DocumentPreSignedUrlsRequestItem[];
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfDocumentPreSignedUrlsRequestItemAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfDocumentPreSignedUrlsRequestItem extends BaseModelOfDocumentPreSignedUrlsRequestItemAndTriumphPayEntities {
}

export interface DocumentPreSignedUrlsRequestItem extends CoreAPIRequestBaseOfDocumentPreSignedUrlsRequestItem {
    documentLabelId: number | null;
    documentTypeId: number;
    fileName: string | null;
}

export interface DocumentMarkPreSignedUploadCompleteRequest {
    companyId: string;
    documentIds: string[];
    documentTypeId: number;
}

export interface DocumentGetS3UrlResponse {
    url: string;
}

export interface BaseRequestOfPostFactorAssignmentRequest {
}

export interface PostFactorAssignmentRequest extends BaseRequestOfPostFactorAssignmentRequest {
    globalCarrierId: string | null;
    payeeRelationships: CurrentPayeeRelationships[] | null;
    note: string;
    currentGlobalFactorCompanyId: string | null;
    requestedFactorCompanyId: string | null;
}

export interface CurrentPayeeRelationships {
    payeeRelationshipId: string;
    currentFactorCompanyId: string | null;
}

export interface ListFactorAssignmentRequestResponse {
    factorAssignmentRequestType: TypeDto | null;
    globalCarrier: GuidDto | null;
    createdUserId: string;
    auditorUserId: string;
    fromFactor: GuidDto | null;
    distinctFromFactorCount: number;
    affectedRelationshipsCount: number | null;
    toFactor: GuidDto | null;
    creatorNote: string;
    factorAssignmentRequestGroupId: string;
    payeeRelationshipCarrier: GuidDto | null;
    auditDateTime: string | null;
    createdDateTime: string;
    isApproved: boolean | null;
    auditorNote: string;
}

export interface GetFactorAssignmentRequestResponse {
    globalCarrier: GuidDto | null;
    payeeRelationshipCarrier: GuidDto | null;
    globalCarrierMcNumber: string;
    globalCarrierDotNumber: string;
    toFactor: GuidDto | null;
    fromGlobalCarrierFactor: GuidDto | null;
    isEditable: boolean;
    affectedRelationships: AffectedRelationshipDto[] | null;
    isApproved: boolean | null;
    totalPendingInvoiceAmount: number;
}

export interface AffectedRelationshipDto {
    id: string | null;
    payeeRelationshipId: number | null;
    payorName: string;
    fromFactor: GuidDto | null;
}

export interface BaseRequestOfPutFactorAssignmentRequest {
}

export interface PutFactorAssignmentRequest extends BaseRequestOfPutFactorAssignmentRequest {
    isApproved: boolean;
    note: string;
}

export interface FactorClientSearchResponse {
    clients: FactorClientSearchResult[];
}

export interface FactorClientSearchResult {
    id: string;
    name: string;
    dotNumbers: string[];
    mcNumbers: string[];
    scacs: string[];
    createdAt: string;
}

export interface RandomUnmatchedFactorClientResponse {
    ids: string[];
}

export interface FactorClientTotalResponse {
    total: number;
}

export interface FactorClientResponse {
    client: ClientField;
    factorAccount: FactorAccountField;
    factoringCompanies: FactoringCompany[];
    factorDataSource: FactorDataSourceField;
    globalCarriers: GlobalCarrier2[];
    importedCarriers: ImportedCarrier2[];
}

export interface ClientField {
    id: string;
    name: string;
    clientType: string;
    notes: string;
    status: string;
    factorDataSourceId: string;
    externalTmsId: string;
    createdAt: string;
    updatedAt: string;
    networkStatus: string | null;
    dotNumbers: string[];
    mcNumbers: string[];
    scacs: string[];
    address: Address2;
    globalCarrierId: string | null;
    matchedById: string | null;
    matchedByEmail: string | null;
    matchedAt: string | null;
    markedConflictedAt: string | null;
    markedConflictedById: string | null;
    markedConflictedByEmail: string | null;
    taxIds: string[];
    dunsNumbers: string[];
    clientDataSourceType: string | null;
    clientDataSourceId: string | null;
}

export interface Address2 {
    line1: string;
    line2: string | null;
    city: string;
    state: string;
    postalCode: string;
    countryCode: string;
}

export interface FactorAccountField {
    id: string;
    name: string;
    factoringCompanyId: string | null;
}

export interface FactoringCompany {
    id: string;
    name: string;
    remitTo: Address2;
    emailAddress: string | null;
    coreCompanyId: number | null;
}

export interface FactorDataSourceField {
    id: string;
    factorAccountId: string | null;
    name: string | null;
    tms: string | null;
    settings: { [key: string]: boolean; };
}

export interface GlobalCarrier2 {
    id: string;
    mcNumbers: string[];
    dotNumbers: string[];
    factoringCompanyId: string | null;
}

export interface ImportedCarrier2 {
    id: string;
    source: string;
    mcNumbers: string[];
    dotNumbers: string[];
    dbaName: string | null;
    companyName: string | null;
    address: Address2;
    createdAt: string;
    updatedAt: string;
    globalCarrierId: string | null;
    fmcsaStatus: string;
    sourceData: SourceData3;
    ein: string | null;
    censusTypeDesc: string | null;
    allowedToOperate: boolean | null;
}

export interface SourceData3 {
    ein: number | null;
    injCrash: number;
    dotNumber: string;
    legalName: string;
    mcNumbers: string[];
    crashTotal: number;
    driverInsp: number;
    fatalCrash: number;
    hazmatInsp: number;
    reviewDate: string | null;
    reviewType: string | null;
    statusCode: string;
    vehicleInsp: number;
    totalDrivers: number | null;
    towawayCrash: number;
    censusTypeId: CensusTypeIdRecord | null;
    driverOosInsp: number;
    driverOosRate: number;
    hazmatOosInsp: number;
    hazmatOosRate: number;
    mcs150Outdated: string;
    physicalAddress: PhysicalAddress;
    vehicleOosInsp: number;
    vehicleOosRate: number;
    carrierOperation: CarrierOperation;
    totalPowerUnits: number | null;
    allowedToOperate: string;
    safetyReviewDate: string | null;
    safetyReviewType: string | null;
    bipdRequiredAmount: number | null;
    isPassengerCarrier: string;
    bipdInsuranceOnFile: number | null;
    bondInsuranceOnFile: number | null;
    bondInsuranceRequired: string | null;
    brokerAuthorityStatus: string | null;
    cargoInsuranceOnFile: number | null;
    commonAuthorityStatus: string | null;
    cargoInsuranceRequired: string | null;
    contractAuthorityStatus: string | null;
    oosRateNationalAverageYear: string;
    driverOosRateNationalAverage: number;
    hazmatOosRateNationalAverage: number;
    vehicleOosRateNationalAverage: number;
}

export interface CensusTypeIdRecord {
    censusType: string;
    censusTypeId: number;
    censusTypeDesc: string;
}

export interface PhysicalAddress {
    street: string;
    city: string;
    state: string;
    zipcode: string;
    country: string;
}

export interface CarrierOperation {
    carrierOperationCode: string;
    carrierOperationDesc: string;
}

export interface MatchFactorClientRequest {
    clientId: string;
    globalCarrierId: string;
    userEmail: string;
}

export interface UnmatchFactorClientRequest {
    clientId: string;
    userEmail: string;
}

export interface MarkConflictedFactorClientRequest {
    clientId: string;
    userEmail: string;
}

export interface FactorDebtorSearchResponse {
    debtors: FactorDebtorSearchResult[];
}

export interface FactorDebtorSearchResult {
    id: string;
    name: string;
    dotNumbers: string[];
    mcNumbers: string[];
    scacs: string[];
    createdAt: string;
}

export interface RandomUnmatchedFactorDebtorResponse {
    ids: string[];
}

export interface FactorDebtorTotalResponse {
    total: number;
}

export interface FactorDebtorResponse {
    debtor: DebtorField;
    factorDataSource: FactorDataSourceField2;
    globalBrokers: GlobalBroker2[];
    importedBrokers: ImportedBroker2[];
}

export interface DebtorField {
    id: string;
    name: string;
    dotNumbers: string[];
    mcNumbers: string[];
    scacs: string[];
    factorDataSourceId: string;
    globalBrokerId: string | null;
    matchedByEmail: string | null;
    matchedAt: string | null;
    markedConflictedByEmail: string | null;
    markedConflictedAt: string | null;
}

export interface FactorDataSourceField2 {
    id: string;
    factorAccountId: string | null;
    name: string | null;
    tms: string | null;
    settings: { [key: string]: boolean; };
}

export interface GlobalBroker2 {
    id: string;
    mcNumbers: string[];
    dotNumbers: string[];
}

export interface ImportedBroker2 {
    id: string;
    source: string;
    mcNumbers: string[];
    dotNumbers: string[];
    dbaName: string | null;
    companyName: string | null;
    createdAt: string;
    updatedAt: string;
    globalBrokerId: string | null;
    fmcsaStatus: string;
    sourceData: SourceData4;
    ein: string | null;
    censusTypeDesc: string | null;
    allowedToOperate: boolean | null;
}

export interface SourceData4 {
    ein: number | null;
    injCrash: number;
    dotNumber: string;
    legalName: string;
    mcNumbers: string[];
    crashTotal: number;
    driverInsp: number;
    fatalCrash: number;
    hazmatInsp: number;
    reviewDate: string | null;
    reviewType: string | null;
    statusCode: string;
    vehicleInsp: number;
    totalDrivers: number | null;
    towawayCrash: number;
    censusTypeId: CensusTypeIdRecord2 | null;
    driverOosInsp: number;
    driverOosRate: number;
    hazmatOosInsp: number;
    hazmatOosRate: number;
    mcs150Outdated: string;
    physicalAddress: PhysicalAddress2;
    vehicleOosInsp: number;
    vehicleOosRate: number;
    brokerOperation: BrokerOperation;
    totalPowerUnits: number | null;
    allowedToOperate: string;
    safetyReviewDate: string | null;
    safetyReviewType: string | null;
    bipdRequiredAmount: number | null;
    isPassengerBroker: string;
    bipdInsuranceOnFile: number | null;
    bondInsuranceOnFile: number | null;
    bondInsuranceRequired: string | null;
    brokerAuthorityStatus: string | null;
    cargoInsuranceOnFile: number | null;
    commonAuthorityStatus: string | null;
    cargoInsuranceRequired: string | null;
    contractAuthorityStatus: string | null;
    oosRateNationalAverageYear: string;
    driverOosRateNationalAverage: number;
    hazmatOosRateNationalAverage: number;
    vehicleOosRateNationalAverage: number;
}

export interface CensusTypeIdRecord2 {
    censusType: string;
    censusTypeId: number;
    censusTypeDesc: string;
}

export interface PhysicalAddress2 {
    street: string;
    city: string;
    state: string;
    zipcode: string;
    country: string;
}

export interface BrokerOperation {
    brokerOperationCode: string;
    brokerOperationDesc: string;
}

export interface MatchFactorDebtorRequest {
    debtorId: string;
    globalBrokerId: string;
    userEmail: string;
}

export interface UnmatchFactorDebtorRequest {
    debtorId: string;
    userEmail: string;
}

export interface MarkConflictedFactorDebtorRequest {
    debtorId: string;
    userEmail: string;
}

export interface SearchGlobalCarrierResponse {
    globalCarrierName: string;
    dotNumber: string | null;
    mcNumber: string | null;
    globalCarrierId: string;
    factor: FactorDto | null;
}

export interface GetGlobalCarrierFactorWillReleaseResponse {
    invoiceAmount: number;
    relationshipCount: number;
}

export interface GetGlobalCarrierFactorPayeeRelationshipsResponse {
    payeeRelationshipId: string;
    payeeCompanyName: string;
    mcNumber: string;
    dotNumber: string;
    factor: FactorDto | null;
    payor: PayorBasicDto | null;
    latestPayeeRelationshipFactorAssignmentDateTime: string | null;
    payeeRelationshipStatus: StatusTypeDto | null;
}

export interface AdminInvoiceItemDto {
    approvedDate: string | null;
    id: string;
    isDrafted: boolean;
    isExported: boolean;
    status: TypeDto | null;
    payor: PayorBasicDto | null;
    initialApprovedStatusDate: string | null;
    referenceNo: string | null;
    invoiceNo: string | null;
    relationship: GuidDto | null;
    grossAmount: number;
    payorAdjustmentAmount: number;
    netAmount: number;
    netAmountAfterPayeeTermFee: number;
    scheduledDraftDate: string | null;
    scheduledPaymentDate: string | null;
    factorName: string | null;
    bankAccount: AdminInvoiceBankDto | null;
    externalInvoiceKey: string | null;
    externalPayeeKey: string | null;
    termCode: string | null;
}

export interface AdminInvoiceBankDto {
    id: string;
    type: TypeDto | null;
    destinationDescription: string | null;
}

export interface GetRelationshipTotalNetAmountByDays_Response {
    totalNetAmount: number;
}

export interface GetRelationshipsMaxInvoiceByRequest {
    payeeRelationshipIds: string[];
}

export interface GetRelationshipTotalNetAmountByDaysRequest extends GetRelationshipsMaxInvoiceByRequest {
    startDate: string;
    endDate: string;
}

export interface GetRelationshipsMaxInvoice_Response {
    maxRelationshipsNetAmount: number | null;
}

export interface ListPayorUnderwritingSnapshot_Response {
    creditLimit: number;
    creditBalance: number;
    invoiceBalance: number;
    payorGuid: string;
    snapshotDate: string;
}

export interface BaseMetricResponse {
    id: number;
    name: string | null;
    description: string | null;
    type: string | null;
}

export interface MetricAggregate extends BaseMetricResponse {
    aggregate: number;
}

export interface ListNoaMetricsByHour_Response {
    forDate: string | null;
    onHour: number | null;
    processQueueTotal: number | null;
    auditQueueTotal: number | null;
    completedTotal: number | null;
    actionConflictQueueTotal: number | null;
    defermentQueueTotal: number | null;
    requestToSplitQueueTotal: number | null;
    pendingNewFactorQueueTotal: number | null;
    total: number | null;
}

export interface MetricWithOccurrences extends BaseMetricResponse {
    occurrences: OccurrenceListItem[] | null;
}

export interface OccurrenceListItem {
    createdDateTime: string;
    value: number;
}

export interface MisdirectedPaymentResponse {
    misdirectedPayments: MisdirectedPaymentDto[];
    totalMultiCurrencyConflatedAmount: number;
}

export interface MisdirectedPaymentDto extends BaseModel {
    misdirectedPaymentId: string;
    createdDateTime: string;
    reverseReason: TypeDto | null;
    payor: GuidDto | null;
    amount: number;
    currencyType: TypeDto;
    paymentRecipient: string;
    transactionCode: string | null;
    reverseTransactionNote: string;
    reversedUserId: string;
    dateCollected: string | null;
    isFundsCollected: boolean;
    isUnappliedCash: boolean;
    isBrokerError: boolean;
}

export interface BaseRequestOfMisdirectedPaymentMarkAsCollectedRequest {
}

export interface MisdirectedPaymentMarkAsCollectedRequest extends BaseRequestOfMisdirectedPaymentMarkAsCollectedRequest {
    amount: number | null;
    note: string;
    isBrokerCharge: boolean | null;
    isWriteOff: boolean | null;
    reverseReasonId: number | null;
}

export interface BaseRequestOfMisdirectedPaymentAddUnappliedCashRequest {
}

export interface MisdirectedPaymentAddUnappliedCashRequest extends BaseRequestOfMisdirectedPaymentAddUnappliedCashRequest {
    payorCompanyId: string;
    amount: number | null;
    bankOfReceiptId: TargetBankAccountOptions;
    paymentRecipient: string;
    note: string;
}

export enum TargetBankAccountOptions {
    Wells = 0,
    TBK = 1,
    RBC = 2,
}

export interface MisdirectedPaymentApplyCashRequest extends BaseRequestOfMisdirectedPaymentAddUnappliedCashRequest {
    note: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfClaimRelationshipRequestAndTriumphPayEntities2 extends BaseModel {
}

export interface CoreAPIRequestBaseOfClaimRelationshipRequest2 extends BaseModelOfClaimRelationshipRequestAndTriumphPayEntities2 {
}

export interface ClaimRelationshipRequest2 extends CoreAPIRequestBaseOfClaimRelationshipRequest2 {
    paymentTermId: string;
}

export interface NetworkCarrierMaxRateGuidDto {
    token: string;
}

export interface NoaRequestListItem {
    payorCompanyId: number | null;
    payorCompanyName: string;
    noaRequestId: number;
    noaRequestGuid: string;
    sourceTypeId: number;
    sourceTypeName: string;
    sourceAddress: string;
    receivedDateTime: string;
    sourceSubjectLine: string;
    pageCount: number;
    processedBy: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfNoaRequestResponseModelAndTriumphPayEntities extends BaseModel {
}

export interface NoaRequestResponseModel extends BaseModelOfNoaRequestResponseModelAndTriumphPayEntities {
    noaRequest: NoaRequestDTO;
    documents: NoaDocumentResponse[];
    originalDocuments: NoaOriginalDocumentResponse[];
    assignment: NoaAssignmentModel;
}

export interface NoaRequestDTO {
    diagnosticId: number;
    clearedOfFraudByUserId: string | null;
    isProcessedByMVC: boolean | null;
    isReleaseRequest: boolean | null;
    hasUserPerformedAction: boolean;
    isLockedByAnotherUser: boolean;
    lockedByUserId: string | null;
    noaRequestSourceTypeId: number;
    sourceDescription: string | null;
    sourceSubjectLine: string | null;
    sourceAddress: string | null;
    note: string | null;
    noteCreatedUserId: string | null;
    noteCreatedDateTime: string | null;
    factorCompanyId: number | null;
    payorCompanyId: number | null;
    spamScore: number | null;
    guid: string;
    receivedDateTime: string;
    noaStatusId: number | null;
    payeeRelationshipId: number | null;
}

export interface NoaOriginalDocumentResponse extends BaseModel {
    id: string;
    noaDocumentStatusId: number;
    originalFileName: string;
    url: string;
}

export interface NoaDocumentResponse extends NoaOriginalDocumentResponse {
    originalNoaDocumentId: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfNoaAssignmentModelAndTriumphPayEntities extends BaseModel {
}

export interface NoaAssignmentModel extends BaseModelOfNoaAssignmentModelAndTriumphPayEntities {
    payeeRelationshipIds: number[] | null;
    factorCompanyId: string | null;
    factorRejectNotificationEmail: string | null;
    isRelease: boolean | null;
    cachedPayorName: string | null;
    cachedPayorGuid: string | null;
    cachedPayorCompanyId: number | null;
    cachedInitialPayeeRelationshipId: string | null;
    cachedInitialPayeeRelationshipCompanyName: string | null;
    cachedFactorName: string | null;
}

export interface GetNoaTotalsByRequestStatus_Response {
    beforeDateTime: string;
    noaStatusId: number;
    requestCount: number;
}

export interface ListTopNoaRequestCountsBySourceAddress_Response {
    sourceAddress: string;
    count: number | null;
}

export interface ListNoaCoachableData_Response {
    noaRequestId: string;
    reviewedDateTime: string;
    incorrectUserId: string;
    correctUserId: string;
    reviewedByUserId: string | null;
    coachingComment: string | null;
}

export interface NoaSearchResponse {
    approvedUserId: string | null;
    noaRequestId: number;
    noaStatus: TypeDTO;
    noaRequestGuid: string;
    createdDateTime: string;
    payorCompanyName: string | null;
    factorCompanyName: string | null;
    payeeCompanyName: string | null;
    reviewedByUserId: string | null;
    processDate: string | null;
    flaggedForReview: boolean | null;
    reviewStatus: string | null;
    rejectReason: string | null;
    reviewedDateTime: string | null;
    actionTaken: string | null;
    userEmail: string | null;
}

export interface ReviewNoaConflictResponse extends BaseModel {
    noaRequestId: string | null;
    noaRequestIdInt: number;
    noaRequestStatusId: number | null;
    approvedActionId: string | null;
    coachingComment: string | null;
    isFraudulentNoaCompletelyProcessed: boolean | null;
    isCoachable: boolean | null;
    isProcessedByMVC: boolean | null;
    reviewedByUserId: string | null;
    reviewedDateTime: string | null;
    noaConflicts: NoaRequestActionResponse[] | null;
    noaDocuments: NoaDocumentResponse[] | null;
    originalDocuments: NoaOriginalDocumentResponse[] | null;
    sourceAddress: string | null;
    documentOcrRequestUrl: string;
}

export interface NoaRequestActionResponse {
    approvedUserId: string | null;
    noaRequestActionId: string | null;
    selectedNoaDocumentId: string | null;
    selectedLorDocumentId: string | null;
    createdDateTime: string;
    createdUser: string;
    currentFactor: TypeStringDto | null;
    assignedPayor: TypeStringDto | null;
    assignedCarrierDotNumber: string | null;
    assignedCarrierMcNumber: string | null;
    assignedCarrierName: string | null;
    releasedFactor: TypeStringDto | null;
    assignedFactor: TypeStringDto | null;
    factorToNotify: TypeStringDto | null;
    emailToNotify: string | null;
    payeeRelationships: NoaConflictPayeeRelationship[] | null;
    pendingReason: string | null;
    rejectedReason: string | null;
    voidDateTime: string | null;
    waitForMC: string | null;
    letterOfReleaseTypeId: number | null;
    isCreatedByOcrAutomation: boolean;
}

export interface NoaConflictPayeeRelationship {
    payeeRelationshipId: string;
    payeeRelationshipIdInt: number;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfSplitNoaRequestAndTriumphPayEntities extends BaseModel {
}

export interface SplitNoaRequest extends BaseModelOfSplitNoaRequestAndTriumphPayEntities {
    requests: SplitNoaRequestPayload[];
    noaRequestId: string;
}

export interface SplitNoaRequestPayload {
    payeeRelationshipId: string | null;
    payorId: string | null;
    documentIds: string[];
    note: string | null;
}

export interface NoaRequestLockResponse {
    noaRequestId: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateNoaRequestCoachingDataRequestAndTriumphPayEntities extends BaseModel {
}

export interface UpdateNoaRequestCoachingDataRequest extends BaseModelOfUpdateNoaRequestCoachingDataRequestAndTriumphPayEntities {
    isCoachable: boolean;
    coachingComment: string | null;
}

export interface BulkRemoveRequest {
    isPermanentlyRemoving: boolean;
    sourceAddress: string;
    sourceSubjectLine: string | null;
    isHeld: boolean;
}

export interface BulkRemoveDryRunResponse extends BaseModel {
    subjectLineFilter: string | null;
    totalCount: number;
    topSubjectLines: { [key: string]: number; };
}

export interface ReverseHeldRequest {
    sourceAddress: string;
}

export interface LorDesignationResponse {
    noaRequestId: string | null;
    approvedNoaRequestAction: NoaRequestActionResponse | null;
    noaDocuments: NoaDocumentResponse[] | null;
    originalDocuments: NoaOriginalDocumentResponse[] | null;
    sourceAddress: string | null;
    totalInvoiceAmount: number;
    payeeRelationshipReleaseCount: number;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfNoaDocumentUpdateModelRequestAndTriumphPayEntities extends BaseModel {
}

export interface NoaDocumentUpdateModelRequest extends BaseModelOfNoaDocumentUpdateModelRequestAndTriumphPayEntities {
    noaRequestId: string;
    noticeOfAssignmentNoaDocumentId: string | null;
    letterOfReleaseNoaDocumentId: string | null;
    noaRejectNotificationAddress: string | null;
    waitForMC: string | null;
    assignedFactorId: string | null;
    releasedFactorId: string | null;
    sourcePayorCompanyId: string | null;
    payeeRelationshipIds: string[];
    noaRejectReasonId: number | null;
    factorToNotifyId: string | null;
    note: string | null;
    letterOfReleaseTypeId: number | null;
    noaStepProcessingTimes: NoaStepProcessingTime[];
}

export interface NoaStepProcessingTime {
    noaStepId: number;
    processingDurationMilliseconds: number;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfNoaRequestResolveConflictRequestAndTriumphPayEntities extends BaseModel {
}

export interface NoaRequestResolveConflictRequest extends BaseModelOfNoaRequestResolveConflictRequestAndTriumphPayEntities {
    approvedActionId: string | null;
    areBothActionsCorrect: boolean | null;
    shouldSendResetRequest: boolean | null;
}

export interface NoaRequestResolveLorDesignationRequest {
    approvedActionId: string | null;
    letterOfReleaseTypeId: number | null;
    shouldSendResetRequest: boolean | null;
}

export interface PayorInfo {
    companyId: number;
    payorGuid: string;
    name: string | null;
    noaEmail: string | null;
    mcNumber: string | null;
    dotNumber: string | null;
    hasLoads: boolean;
}

export interface MatchedRelationshipItem {
    dotNumber: string | null;
    mcNumber: string | null;
    payeeRelationshipId: string;
    companyName: string | null;
    isFactorOverride: boolean;
    isFactored: boolean;
    actualFactorCompanyId: string | null;
    overrideFactorName: string | null;
    requestedFactorName: string | null;
    payorCompanyId: string;
    payorCompanyName: string | null;
}

export interface SearchNoaFactorByCompanyNameResult {
    companyId: string;
    name: string;
    apEmailAddress: string | null;
}

export interface MatchingPayeeRelationshipItem {
    factorCompanyId: string | null;
    payorName: string | null;
    payorCompanyId: string | null;
    payeeRelationshipId: string | null;
    payeeRelationshipIntId: number;
    companyName: string | null;
    dotNumber: string | null;
    mcNumber: string | null;
    scac: string | null;
    factorName: string | null;
    tmsFactorCompanyId: number | null;
    tmsFactorName: string | null;
    hasMissingLorEvent: number;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfManualAssignmentRequestAndTriumphPayEntities extends BaseModel {
}

export interface ManualAssignmentRequest extends BaseModelOfManualAssignmentRequestAndTriumphPayEntities {
    documents: DocumentAddRequestItem2[];
    payeeRelationshipId: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfDocumentAddRequestItemAndTriumphPayEntities2 extends BaseModel {
}

export interface CoreAPIRequestBaseOfDocumentAddRequestItem2 extends BaseModelOfDocumentAddRequestItemAndTriumphPayEntities2 {
}

export interface DocumentAddRequestItem2 extends CoreAPIRequestBaseOfDocumentAddRequestItem2 {
    fileData: string;
    fileName: string;
}

export interface NoaMissingLORRequest {
    noaRequestId: string;
    payeeRelationshipIds: string[];
}

export interface NoteCollectionResponse {
    count: number;
    notes: NoteResponse[];
}

export interface NoteResponse {
    id: string;
    noteTypeId: number;
    foreignId: string;
    message: string;
    createdDateTime: string;
    createdUserId: string | null;
}

export interface NoteDto {
    id: number;
    guid: string;
    noteTypeId: number;
    foreignGuid: string;
    message: string;
    createdDateTime: string;
    createdUserId: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfNoteRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfNoteRequest extends BaseModelOfNoteRequestAndTriumphPayEntities {
}

export interface NoteRequest extends CoreAPIRequestBaseOfNoteRequest {
    noteTypeId: number;
    foreignId: string;
    message: string;
}

export interface GetRelationshipInfoResponse {
    company: PaperworkCompanyInfo;
    paymentTerm: PaperworkPaymentTermInfo | null;
    payor: PaperworkPayorInfo;
    relationship: PaperworkRelationshipInfo | null;
}

export interface PaperworkCompanyInfo {
    dotNumber: string | null;
    mcNumber: string | null;
    name: string;
}

export interface PaperworkPaymentTermInfo {
    daysToPay: number;
    isQuickPay: boolean;
    percentageFee: number;
}

export interface PaperworkPayorInfo {
    address: AddressDto;
    apEmail: string;
    currencyType: TypeDto;
    id: string;
    name: string;
    primaryEmail: string;
}

export interface PaperworkRelationshipInfo {
    address: AddressDto;
    assignedFactor: FactorDto | null;
    dotNumber: string;
    externalPayeeKey: string;
    id: string;
    name: string;
    mcNumber: string;
}

export interface GetRelationshipInfoRequest {
    payeeId: string;
    payeeRelationshipId: string | null;
    payorId: string;
}

export interface ListPayeesAndCompaniesResult {
    name: string;
    id: string;
    mcNumber: string;
    dotNumber: string;
    scac: string | null;
    companyId: number;
}

export interface AdminPayorDto extends BaseModel {
    currencyType: TypeDto | null;
    dotNumber: string | null;
    id: string;
    mcNumber: string | null;
    name: string | null;
    payorData: TypeDto[] | null;
}

export interface AdminPayorListDto {
    displayName: string | null;
    id: string;
    isActive: boolean;
    isNoPay: boolean;
    lastUpdatedBy: string | null;
    lastUpdatedOn: string;
    legalName: string | null;
    integrationType: TypeDto | null;
    payorType: TypeDto | null;
    termCodes: string[] | null;
}

export interface AdminPayorFullDto {
    accountExec: GuidDto | null;
    currencyType: TypeDto | null;
    creditLimit: number | null;
    deltaClientId: number | null;
    displayName: string | null;
    firstFunding: string | null;
    goLiveDateTime: string | null;
    billingStartDateTime: string | null;
    iconData: string | null;
    id: string;
    isActive: boolean;
    isSelectCarrierCompliant: boolean;
    lastUpdatedBy: string | null;
    lastUpdatedOn: string;
    legalName: string | null;
    operationsNoPay: NoPayDto | null;
    payorType: TypeDto | null;
    payorTierType: EnumTypeDtoOfPayorTierTypeId | null;
    payorSubType: TypeDto | null;
    underwritingNoPay: NoPayDto | null;
    draftBankAccount: PayorBankAccountDto | null;
    settlementBankAccount: PayorBankAccountDto | null;
    inactiveBankAccounts: PayorBankAccountDto[] | null;
    incomingEftBankAccount: TypeDto | null;
    carrierContact: PayorContactDto | null;
    triumphContact: PayorContactDto | null;
    mcNumber: string | null;
    dotNumber: string | null;
    noaEmail: string | null;
    apEmail: string | null;
    qpEmail: string | null;
    spEmail: string | null;
    customerBillingEmail: string | null;
    website: string | null;
    address: AddressDto | null;
    draftSchedule: DraftScheduleDto | null;
    payoutDestinationFees: PayoutDestinationFeeDto[] | null;
    payoutTerms: PayorPayoutTermDto[] | null;
    advanceTerms: PayorAdvanceTermDto[] | null;
    subscriptionFees: PayorSubscriptionFeeDto[] | null;
    integrationFee: PayorFeeDto | null;
    carrierCategories: TypeDto[] | null;
    noaSourceOfTruth: string | null;
    isUsingTransferMateCurrency: boolean;
    isDraftBankAccountAllowed: boolean;
    isTriumphLoadAdvancesEnabled: boolean;
}

export interface NoPayDto extends BaseModel {
    isNoPay: boolean;
    isNoDraft: boolean;
    description: string | null;
}

export interface BaseTypeDtoOfPayorTierTypeId {
    id: PayorTierTypeId;
    name: string | null;
}

export interface EnumTypeDtoOfPayorTierTypeId extends BaseTypeDtoOfPayorTierTypeId {
}

export interface PayorBankAccountDto {
    bankAccountType: BankAccountTypeDto;
    beneficiaryName: string;
    createdBy: string;
    createdOn: string;
    destinationDescription: string;
    id: string;
    isActive: boolean;
    isVerified: boolean;
    isDraft: boolean;
    verifiedBy: string | null;
    verifiedOn: string | null;
}

export interface PayorContactDto {
    email: string | null;
    name: string | null;
    phone: string | null;
}

export interface DraftScheduleDto {
    frequency: string | null;
    dayOfWeek: string | null;
    maxDaysToDelay: number | null;
}

export interface PayoutDestinationFeeDto extends TypeDto {
    defaultFee: number | null;
    overrideFee: number | null;
}

export interface PayorPayoutTermDto {
    code: string;
    description: string;
    escrowPeriod: number | null;
    financePeriod: number | null;
    payPeriod: number;
    factorOverridePayPeriod: number | null;
    termUserLimit: EnumTypeDtoOfPayoutTermUserLimitId;
    isActive: boolean;
    isQuickPay: boolean;
    isAvailableToFactor: boolean;
    termCategories: TypeDto[];
    payoutTermType: EnumTypeDtoOfPayoutTermTypeId;
    payeePercentageFee: number;
    payeeFlatFee: number;
    payeePercentageFeePayorShare: number;
    payorPercentageFee: number;
    payorGotpPercentageFee: number;
    payorFlatFee: number;
    gotpPreventCompounding: boolean;
}

export interface BaseTypeDtoOfPayoutTermUserLimitId {
    id: PayoutTermUserLimitId;
    name: string | null;
}

export interface EnumTypeDtoOfPayoutTermUserLimitId extends BaseTypeDtoOfPayoutTermUserLimitId {
}

export enum PayoutTermUserLimitId {
    PayeeTerms = 1,
    PayorAndPayeeTerms = 2,
    AllTerms = 3,
}

export interface BaseTypeDtoOfPayoutTermTypeId {
    id: PayoutTermTypeId;
    name: string | null;
}

export interface EnumTypeDtoOfPayoutTermTypeId extends BaseTypeDtoOfPayoutTermTypeId {
}

export interface PayorAdvanceTermDto {
    advanceRatePercentage: number;
    advanceType: EnumTypeDtoOfAdvanceTypeId;
    amountsMustMatch: boolean;
    code: string;
    daysToPay: number;
    description: string;
    isActive: boolean;
    payeePercentageFee: number;
    payeeFlatFee: number;
    /** The maximum amount an advance may be. This is an amount cap that (AdvanceRatePercentage * amount) cannot exceed. */
    maximumAdvanceAmount: number | null;
    /** Payee pays this, and it is given to the payor */
    payorPayeePercentageFee: number | null;
    /** Payee pays this, and it is given to the payor */
    payorPayeeFlatFee: number | null;
    /** Payor pays this to Triumph */
    payorPercentageFee: number | null;
    /** Payor pays this to Triumph */
    payorFlatFee: number | null;
}

export interface BaseTypeDtoOfAdvanceTypeId {
    id: AdvanceTypeId;
    name: string | null;
}

export interface EnumTypeDtoOfAdvanceTypeId extends BaseTypeDtoOfAdvanceTypeId {
}

export interface PayorSubscriptionFeeDto {
    modeCode: string | null;
    isActive: boolean;
    isQuickPayExempt: boolean;
    baseFeePerPeriod: number;
    invoicesPerPeriod: number;
    overageFeePerInvoice: number;
}

export interface PayorFeeDto {
    description: string | null;
    isActive: boolean;
    amount: number;
    payorFeeType: TypeDto;
}

export interface PayorProfileSettingDto extends TypeDto {
    category: TypeDto | null;
    description: string | null;
    isEditable: boolean;
    profileTypeFormat: TypeDto | null;
    currentValue: string | null;
    defaultValue: string | null;
    valueOptions: string[] | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfPayorProfileSettingRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfPayorProfileSettingRequest extends BaseModelOfPayorProfileSettingRequestAndTriumphPayEntities {
}

export interface PayorProfileSettingRequest extends CoreAPIRequestBaseOfPayorProfileSettingRequest {
    id: number;
    currentValue: string | null;
}

export interface PayorTransferMateSettingsDto {
    globalAccountId: number;
    ultimateDebtorId: number;
}

export interface ValidatedTransferMateSettingDto {
    globalAccountDetails: GlobalAccountDetails | null;
    globalAccountId: string;
    ultimateDebtorDetails: UltimateDebtorDetails | null;
    ultimateDebtorId: string;
}

export interface GlobalAccountDetails {
    accountCurrency: string;
    accountDescription: string;
    accountName: string;
    accountNumber: string;
}

export interface UltimateDebtorDetails {
    city: string;
    country: string;
    name: string;
    reconciliationId: string;
    state: string;
    ultimateDebtorType: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfAddPayorRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfAddPayorRequest extends BaseModelOfAddPayorRequestAndTriumphPayEntities {
}

export interface AddPayorRequest extends CoreAPIRequestBaseOfAddPayorRequest {
    factorsoftClientKey: number | null;
    currencyTypeId: number;
    payorTypeId: number;
    payorTierTypeId: PayorTierTypeId;
    payorSubTypeId: number | null;
    legalName: string;
    companyName: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdatePayorRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdatePayorRequest extends BaseModelOfUpdatePayorRequestAndTriumphPayEntities {
}

export interface UpdatePayorRequest extends CoreAPIRequestBaseOfUpdatePayorRequest {
    accountExec: GuidDto | null;
    currencyType: TypeDto | null;
    creditLimit: number | null;
    deltaClientId: number | null;
    displayName: string | null;
    isActive: boolean | null;
    isSelectCarrierCompliant: boolean | null;
    legalName: string | null;
    payorType: TypeDto | null;
    payorTierType: EnumTypeDtoOfPayorTierTypeId | null;
    payorSubType: TypeDtoOptionalId | null;
    underwritingNoPay: NoPayDto | null;
    incomingEftBankAccount: TypeDto | null;
    carrierContact: PayorContactDto | null;
    triumphContact: PayorContactDto | null;
    mcNumber: string | null;
    dotNumber: string | null;
    noaEmail: string | null;
    apEmail: string | null;
    qpEmail: string | null;
    spEmail: string | null;
    customerBillingEmail: string | null;
    website: string | null;
    billingStartDateTime: string | null;
    integrationFee: number | null;
    address: AddressDto | null;
    draftSchedule: DraftScheduleDto | null;
    payoutDestinationFees: PayoutDestinationFeeDto[] | null;
}

export interface TypeDtoOptionalId {
    id: number | null;
}

export interface BankAccountRequirements {
    isStandardTemplate: boolean;
    bankAccountTypeId: number;
    bankAccountTypeName: string;
    isAddressRequired: boolean;
    isBankABANumberRequired: boolean;
    isBankABANumberValidated: boolean;
    isBankABANumbersOnly: boolean;
    bankABANumberDigitCount: number | null;
    bankABANumberMinDigitCount: number | null;
    bankABANumberTerm: string;
    isBankAccountNumberRequired: boolean;
    bankAccountNumberTerm: string;
    bankAccountNumberDigitCount: number | null;
    isIntermediaryBankABANumberRequired: boolean;
    isIntermediaryBankABANumberValidated: boolean;
    intermediaryBankABANumberTerm: string;
    intermediaryBankABANumberDigitCount: number | null;
    skipConfirmAccountNumber: boolean;
    isRemitCountryRequired: boolean;
    isBankCountryRequired: boolean;
    defaultCountry: string | null;
    addressTerm: string;
    remitStateStringLength: number | null;
    isRemitNameRequired: boolean;
    isStateFieldRequired: boolean;
    isStateIsoCodeRequired: boolean;
    remitNameTerm: string;
    isRemitNameAllowed: boolean;
    isAdditionalAccountFieldRequired: boolean;
    additionalAccountFieldDigitCount: number | null;
    additionalAccountFieldMinDigitCount: number | null;
    additionalAccountFieldTerm: string;
    countryRequirements: { [key in keyof typeof Alpha2Code]?: CountryRequirement; } | null;
    defaultCountryRequirements: CountryRequirement | null;
}

export interface CountryRequirement {
    isBankABANumberSwift: boolean;
    isUsOrCaPostalCode: boolean;
    confirmBankAccountNumberLabel: string | null;
    bankAccountNumberComponents: BankAccountNumberComponents | null;
    postalCode: BankFieldRequirement | null;
    isAdditionalAccountFieldSwift: boolean;
}

export interface BankAccountNumberComponents {
    field1: BankFieldRequirement;
    field2: BankFieldRequirement | null;
}

export interface BankFieldRequirement {
    digitCount: number | null;
    isRequired: boolean;
    isABA: boolean | null;
    label: string | null;
    defaultValue: string | null;
    isSwift: boolean | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfAddPayorBankRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfAddPayorBankRequest extends BaseModelOfAddPayorBankRequestAndTriumphPayEntities {
}

export interface AddPayorBankRequest extends CoreAPIRequestBaseOfAddPayorBankRequest {
    bankAccountTypeId: number;
    beneficiaryName: string;
    routingNumber: string | null;
    address: AddressDto | null;
    intermediaryRoutingNumber: string | null;
    bankAccountNumber: string | null;
    confirmBankAccountNumber: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfVerifyPayorBankRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfVerifyPayorBankRequest extends BaseModelOfVerifyPayorBankRequestAndTriumphPayEntities {
}

export interface VerifyPayorBankRequest extends CoreAPIRequestBaseOfVerifyPayorBankRequest {
    routingNumber: string | null;
    intermediaryRoutingNumber: string | null;
    bankAccountNumber: string | null;
    address: AddressDto | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateAdvanceTermRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateAdvanceTermRequest extends BaseModelOfUpdateAdvanceTermRequestAndTriumphPayEntities {
}

export interface UpdateAdvanceTermRequest extends CoreAPIRequestBaseOfUpdateAdvanceTermRequest {
    advanceTypeId: AdvanceTypeId;
    description: string | null;
    advanceRatePercentage: number;
    payeePercentageFee: number;
    payeeFlatFee: number;
    requireApprovedAmountEqualCharges: boolean;
    daysToPay: number;
    /** The maximum amount an advance may be. This is an amount cap that (AdvanceRatePercentage * amount) cannot exceed. */
    maximumAdvanceAmount: number | null;
    /** Payee pays this, and it is given to the payor */
    payorPayeePercentageFee: number | null;
    /** Payee pays this, and it is given to the payor */
    payorPayeeFlatFee: number | null;
    /** Payor pays this to Triumph */
    payorPercentageFee: number | null;
    /** Payor pays this to Triumph */
    payorFlatFee: number | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdatePayoutTermRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdatePayoutTermRequest extends BaseModelOfUpdatePayoutTermRequestAndTriumphPayEntities {
}

export interface UpdatePayoutTermRequest extends CoreAPIRequestBaseOfUpdatePayoutTermRequest {
    description: string;
    escrowPeriod: number | null;
    financePeriod: number | null;
    gotpPreventCompounding: boolean;
    payPeriod: number;
    factorOverridePayPeriod: number | null;
    termUserLimitId: PayoutTermUserLimitId;
    payoutTermType: PayoutTermTypeId;
    isAvailableToFactor: boolean;
    termCategoryIds: number[];
    payeePercentageFee: number;
    payeeFlatFee: number;
    payeePercentageFeePayorShare: number;
    payorPercentageFee: number;
    payorGotpPercentageFee: number;
    payorFlatFee: number;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfUpdateSubscriptionFeeRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfUpdateSubscriptionFeeRequest extends BaseModelOfUpdateSubscriptionFeeRequestAndTriumphPayEntities {
}

export interface UpdateSubscriptionFeeRequest extends CoreAPIRequestBaseOfUpdateSubscriptionFeeRequest {
    /** The number of invoices included in the subscription, which do not attract an overage charge */
    invoicesPerPeriod: number;
    /** The minimum amount charged to the Payor each month regardless of usage */
    baseFeePerPeriod: number;
    /** The amount charged to the Payor for each invoice beyond the limit specified by InvoicesPerPeriod. */
    overageFeePerInvoice: number;
    /** If true, only standard pay invoices count toward this subscription's monthly limit and overages.
If false, both standard and QuickPay invoices are counted. */
    isQuickPayExempt: boolean;
}

export interface UpdatePayorIntegrationFeeRequest {
    amount: number;
}

export interface PromotionalCampaignDto {
    endDate: string;
    id: string;
    invoiceAmount: number;
    invoiceCount: number;
    payor: GuidDto;
    relationshipCount: number;
    startDate: string;
    status: TypeDto;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfAddPromotionalCampaignRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfAddPromotionalCampaignRequest extends BaseModelOfAddPromotionalCampaignRequestAndTriumphPayEntities {
}

export interface AddPromotionalCampaignRequest extends CoreAPIRequestBaseOfAddPromotionalCampaignRequest {
    endDate: string;
    startDate: string;
    maxInvoiceAmount: number;
    invoiceCount: number;
    fileData: string;
    fileName: string;
}

export interface ListPromotionalCampaignsResponse {
    promotionalCampaigns: PromotionalCampaignDto[];
}

export interface ListPromotionalCampaignPayorsReponse {
    payors: GuidDto[];
}

export interface GetPromotionalCampaignResponse {
    promotionalCampaign: PromotionalCampaignDto;
}

export interface GetPromotionalCampaignRelationshipsResponse {
    campaignRelationships: CampaignRelationshipDto[];
}

export interface CampaignRelationshipDto {
    dotNumber: string;
    firstQuickpayInvoicePaidDate: string | null;
    id: string;
    mcNumber: string;
    name: string;
    paymentTerm: PaymentTermDto | null;
    promotionalInvoiceExpirationDate: string | null;
    quickpayElectedDate: string | null;
    relationshipClaimedDate: string | null;
    remainingInvoiceCount: number;
    status: TypeDto;
}

export interface AdminListRelationshipResponse {
    payeeRelationships: RelationshipDto[];
}

export interface CreditLimitExceededResponse {
    results: OverCreditItem[];
}

export interface OverCreditItem {
    acknowledgedDateTime: string | null;
    acknowledgeUserId: string | null;
    creditLimit: number;
    mcNumber: string | null;
    overCreditStart: string;
    overCreditEnd: string | null;
    outstandingApprovedInvoiceBalance: number;
    outstandingBalance: number;
    payor: GuidDto;
}

export interface PayDateChangeSummaryItem {
    averageDaysChanged: number;
    count: number;
    payor: GuidDto;
}

export interface PayDateChangeItem {
    relationship: GuidDto | null;
    originalScheduledPayDate: string;
    newScheduledPayDate: string;
    invoiceNo: string;
    referenceNo: string;
    netAmount: number;
}

export interface PayoutsBoundsCheck_SP_Response {
    payee: string;
    payeeGuid: string | null;
    transactionCode: string | null;
    paidAmount: number;
    invoiceNetAmount: number | null;
    overPaidAmount: number | null;
    paymentCreationDate: string;
    destinationDescription: string;
}

export interface LoginReportResponse {
    loginReportItems: LoginListItem[];
}

export interface LoginListItem {
    userGuid: string | null;
    loginName: string;
    loginType: string;
    loginTime: string;
}

export interface ImportExceptionResponse {
    importExceptionItems: ImportExceptionItem[];
}

export interface ImportExceptionItem {
    companyName: string | null;
    companyId: number | null;
    createdDateTime: string;
    createdUserId: string | null;
    eventLogName: string | null;
    externalKey: string | null;
    errorMessage: string | null;
    s3Url: string | null;
}

export interface IntegrationActivityReportResponse {
    integrationActivityReportItems: IntegrationActivityReportItem[];
}

export interface IntegrationActivityReportItem {
    companyId: number;
    payorGuid: string;
    importType: string | null;
    lastActivityTime: string | null;
}

export interface PdfResponse {
    data: string;
}

export interface ListSelectCarriers_Response {
    name: string;
    payeeCompanyId: number;
    id: string;
    mcNumber: string;
    dotNumber: string;
    factored: boolean | null;
    claimedPrAll: number;
    unclaimedPrAll: number;
    claimedPrQuickPay: number;
    openedDateTime: string | null;
    clickedDateTime: string | null;
    sentDateTime: string | null;
    maxUnclaimedCreatedDate: string | null;
    factoredRelationshipsCount: number;
}

export interface GetSelectCarrierResponse {
    invitationEmail: SelectCarrierInvitationEmail | null;
    carrierEmailAddresses: string[];
    largestQuickPay: number | null;
    name: string;
    payeeCompanyId: string;
    id: string;
    phoneNumber: string;
    notes: string;
    mcNumber: string;
    dotNumber: string;
    removalNotes: SelectCarrierRemovalNote[];
    factorName: string | null;
    bankInfo: SelectCarrierBankInfo;
    contactName: string | null;
    scacNumber: string | null;
    currentStatus: CurrentSelectCarrierStatus;
    factorId: string | null;
}

export interface SelectCarrierInvitationEmail {
    id: number;
    dateSent: string;
    dateOpened: string | null;
    dateClicked: string | null;
    rateOffer: number;
    senderName: string;
    senderEmail: string;
    senderPhone: string;
    recipientEmail: string;
    recipientName: string;
    opportunityId: number | null;
    coreOfferGuid: string | null;
}

export interface SelectCarrierRemovalNote {
    id: number | null;
    opportunityId: number | null;
    note: string;
    createdDateTime: string | null;
}

export interface SelectCarrierBankInfo {
    name: string;
    shortName: string;
}

export interface CurrentSelectCarrierStatus {
    status: SelectCarrierStatus;
    rate: number | null;
    updatedOn: string | null;
    updatedBy: string | null;
}

export interface SelectCarrierStatus extends DataAccessObjectBaseOfTriumphPayConstants {
    id: number;
    name: string;
}

export interface InviteSelectCarrierRequest {
    recipientCarrierName: string;
    recipientContactName: string;
    recipientEmail: string;
    rateOffer: number;
    senderName: string;
    senderPhone: string;
    senderEmail: string;
}

export interface SelectCarrierTMSDataResponse {
    mcNumbers: string[] | null;
    dotNumbers: string[] | null;
    phoneNumbers: string[] | null;
    emailAddresses: string[] | null;
    addresses: Address3[] | null;
}

export interface Address3 {
    addr1: string | null;
    addr2: string | null;
    city: string | null;
    state: string | null;
    postalCode: string | null;
    country: string | null;
}

export interface RemoveSelectCarrierRequest {
    removalNote: string;
}

export interface BaseRequestOfUpdateSelectCarrierRequest {
}

export interface UpdateSelectCarrierRequest extends BaseRequestOfUpdateSelectCarrierRequest {
    notes: string | null;
    statusId: number | null;
}

export interface GetTriumphLoadAdvancePayorsResponse {
    fullCount: number;
    payors: AdminTriumphLoadAdvancePayorListDto[];
}

export interface AdminTriumphLoadAdvancePayorListDto {
    payor: GuidDto;
    /** Sum of credit exposures for each Payee.
Advance amount that has been paid to Carrier, but not recoursed. */
    relationshipsCreditExposure: number;
    /** Sum of credit limits for each Payee.
There should only be one PayeeRelationship per Payee in this data set - if not, this will overreport Credit Limit amount. */
    relationshipTotalCreditLimit: number;
    creditExposurePercentage: number;
}

export interface GetTriumphLoadAdvancePayorResponse {
    fullCount: number;
    payor: GuidDto;
    relationships: AdminTriumphLoadAdvancePayorRelationshipDto[];
}

export interface AdminTriumphLoadAdvancePayorRelationshipDto {
    amountExceedingCreditLimit: number;
    creditLimit: number;
    creditUtilizationPercentage: number;
    creditExposure: number;
    /** PayeeRelationship.PayeeRelationshipGuid */
    id: string;
    /** Payee Company Name */
    name: string;
}

export interface GetTriumphLoadAdvanceRelationshipResponse {
    advances: AdminRelationshipTriumphLoadAdvanceDto[];
    payor: GuidDto;
    /** Id = PayeeRelationshipGuid
Name = Payee Company Name */
    relationship: GuidDto;
}

export interface AdminRelationshipTriumphLoadAdvanceDto {
    /** Advance Guid */
    id: string;
    advanceTermCode: string;
    externalLoadKey: string;
    advancePaidDate: string | null;
    /** Amount before fees. */
    grossAmount: number;
    feeAmount: number;
    /** Amount after fees. */
    netAmount: number;
    recoursedAmount: number;
    /** Amount not recoursed. */
    outstandingBalance: number;
}

export interface GetUnreconciledFundsPayorsResponse {
    fullCount: number;
    payors: AdminUnreconciledFundsPayorListDto[];
}

export interface AdminUnreconciledFundsPayorListDto {
    currencyType: TypeDto;
    mostRecentTransactionDate: string;
    payor: GuidDto;
    payorRebateBalance: number;
    unreconciledFundsBalance: number;
}

export interface GetUnreconciledFundsPayorTransactionsResponse {
    fullCount: number;
    payor: GuidDto;
    transactions: AdminUnreconciledFundsTransactionDto[];
}

export interface AdminUnreconciledFundsTransactionDto {
    batchIds: string[];
    creditAmount: number;
    fundedAmount: number;
    date: string;
    id: string;
    note: string;
    status: EnumTypeDtoOfUnreconciledFundsStatusId;
    transactionId: number;
}

export interface BaseTypeDtoOfUnreconciledFundsStatusId {
    id: UnreconciledFundsStatusId;
    name: string | null;
}

export interface EnumTypeDtoOfUnreconciledFundsStatusId extends BaseTypeDtoOfUnreconciledFundsStatusId {
}

export enum UnreconciledFundsStatusId {
    Reversed = 1,
    Unreconciled = 2,
}

export interface GetUnreconciledFundsStatusesResponse {
    statuses: EnumTypeDtoOfUnreconciledFundsStatusId[];
}

export interface GetUnreconciledFundsPayorAccountsResponse {
    defaultCreditAccount: TypeDto;
    defaultDebitAccount: TypeDto | null;
    financialAccounts: TypeDto[];
}

export interface AddUnreconciledFundsRequest {
    amount: number;
    creditAccountId: number;
    date: string;
    debitAccountId: number;
    note: string;
    payorCompanyId: string;
}

export interface ReverseUnreconciledFundsRequest {
    note: string | null;
    reversalDate: string;
    payorRebateAmount: number | null;
}

export interface UpdateUnreconciledFundsNoteRequest {
    guid: string;
    note: string;
}

export interface EmailAddressModel {
    emailAddresses: string[];
}

export interface GenerateInternalIntegrationRefreshTokenResponse {
    user_refresh_token: string;
    user_account_name: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfGenerateUnifiedAPIRefreshTokenRequestAndTriumphPayEntities extends BaseModel {
}

export interface GenerateUnifiedAPIRefreshTokenRequest extends BaseModelOfGenerateUnifiedAPIRefreshTokenRequestAndTriumphPayEntities {
    unified_api_account_id: string;
    payor_guid: string;
    admin_user_okta_id: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfGenerateSupplyChainFinanceUnifiedAPIRefreshTokenRequestAndTriumphPayEntities extends BaseModel {
}

export interface GenerateSupplyChainFinanceUnifiedAPIRefreshTokenRequest extends BaseModelOfGenerateSupplyChainFinanceUnifiedAPIRefreshTokenRequestAndTriumphPayEntities {
    unified_api_account_id: string;
    payor_guid: string;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfGenerateAuditAPIRefreshTokenRequestAndTriumphPayEntities extends BaseModel {
}

export interface GenerateAuditAPIRefreshTokenRequest extends BaseModelOfGenerateAuditAPIRefreshTokenRequestAndTriumphPayEntities {
    audit_account_id: string;
    payor_guid: string;
    admin_user_okta_id: string;
    admin_user_email_address: string | null;
}

export interface CsrSearchResult {
    allPayors: CsrSearchPayorModel[];
    allPayees: (CsrSearchPayeeModel | null)[];
    allPayeeRelationships: CsrSearchPayeeRelationshipModel[];
    invoices: CsrSearchInvoiceResult[];
    loads: CsrSearchLoadResult[];
}

export interface CsrSearchPayorModel {
    name: string;
    payorId: string;
    contactName: string | null;
    contactPhone: string | null;
    email: string | null;
    accountExecutive: string | null;
    currencyTypeId: number;
    submitsLoadData: boolean;
}

export interface CsrSearchPayeeModel {
    name: string;
    payeeId: string;
    dotNumber: string | null;
    mcNumber: string | null;
    isSelectCarrier: boolean;
}

export interface CsrSearchPayeeRelationshipModel {
    payeeRelationshipId: string;
    payeeName: string;
    payeeId: string | null;
    mcNumber: string | null;
    dotNumber: string | null;
    payorId: string;
    payorName: string;
    payorIconData: string | null;
    address: AddressDto | null;
    email: string | null;
    phoneNumber: string | null;
    bankAccount: BankAccountDto | null;
    isClaimed: boolean | null;
    isFactored: boolean | null;
    status: StatusTypeDto;
    heldReason: string | null;
    factorId: string | null;
    factorName: string | null;
    payee: CsrSearchPayeeModel | null;
    externalPayeeKey: string | null;
}

export interface CsrSearchInvoiceResult {
    payor: CsrSearchPayorModel;
    payeeRelationship: CsrSearchPayeeRelationshipModel | null;
    payee: CsrSearchPayeeModel | null;
    invoice: CsrSearchInvoiceModel | null;
}

export interface CsrSearchInvoiceModel {
    invoiceId: string;
    payeeRelationshipId: string | null;
    payorId: string;
    payeeId: string | null;
    invoiceNumber: string | null;
    payeeName: string | null;
    payeeMcNumber: string | null;
    payorName: string | null;
    invoiceStatus: StatusTypeDto | null;
    uploadedDate: string | null;
    approvedDate: string | null;
    scheduledDate: string | null;
    scheduledDraftDate: string | null;
    lineItems: LineItemDto[];
    referenceNumber: string | null;
    isQuickPay: boolean;
    bankAccount: BankAccountDto | null;
    grossAmount: number | null;
    netAmount: number | null;
    paymentTermName: string;
    paymentId: string | null;
}

export interface CsrSearchLoadResult {
    payor: CsrSearchPayorModel;
    payeeRelationship: CsrSearchPayeeRelationshipModel | null;
    payee: CsrSearchPayeeModel | null;
    load: LoadDto | null;
}

export interface StopPaymentsResponse {
    payorId: string;
    success: boolean;
    errorMessage: string | null;
}

/** DB context-aware extension of the BaseModel */
export interface BaseModelOfStopPaymentsRequestAndTriumphPayEntities extends BaseModel {
}

export interface CoreAPIRequestBaseOfStopPaymentsRequest extends BaseModelOfStopPaymentsRequestAndTriumphPayEntities {
}

export interface StopPaymentsRequest extends CoreAPIRequestBaseOfStopPaymentsRequest {
    stopPayments: boolean;
    stopDrafts: boolean;
    reason: string | null;
    payorId: string;
}

export interface CreditLimitBlockedCountModel extends BaseModel {
    blockedCount: number;
}

export interface ReviewCreditLimitResult {
    results: PayorCreditLimitReviewItem[];
}

export interface PayorCreditLimitReviewItem {
    creditLimit: number;
    currentExposure: number;
    availableCredit: number;
    currencyType: TypeDto;
    itemsExceedingCreditLimitCount: number;
    payorCompanyId: number;
    payorGuid: string;
    payorCompanyName: string;
    scheduledFundingImpactingCredit: number;
}

export interface UnderwritingSummaryResponse {
    bankChangeRequestCount: number;
    pendingInvoiceAmount: number;
    averageCompletionTime: number;
}

export interface UnderwritingPayorExposuresResponse {
    payorId: string;
    creditLimit: number;
    details: PayorExposure[];
}

export interface PayorExposure {
    date: string;
    exposure: number;
    invoiceBalance: number;
}

//